/* 한국어 — Korean */
const ko = {
  nav: {
    home: '홈',
    imageConverter: '이미지 변환',
    imageCompressor: '이미지 압축',
    otherTools: '기타 도구',
    resizeImage: '이미지 크기 조정',
    cropImage: '이미지 자르기',
    photoEditor: '사진 편집기',
    removeBackground: '배경 제거',
    watermarkImage: '워터마크',
    qrCodeGenerator: 'QR 코드 생성기',
    qrCodeScanner: 'QR 코드 스캐너',
    aboutUs: '소개',
    faceBlur: '얼굴 블러',
  },

  hero: {
    heading: '필요한 모든 이미지 도구',
    subheading: '이미지를 변환, 압축, 크기 조정, 자르기, 편집, 변환하는 무료 온라인 도구. 모든 처리는 브라우저에서 이루어집니다 — 빠르고 안전합니다.',
  },

  tools: {
    compressImage: { title: '이미지 압축', desc: 'JPG, PNG, SVG, GIF를 품질을 유지하면서 압축합니다.' },
    resizeImage: { title: '이미지 크기 조정', desc: '퍼센트나 픽셀로 크기를 조정합니다.' },
    cropImage: { title: '이미지 자르기', desc: 'JPG, PNG, GIF를 손쉽게 자릅니다.' },
    convertToJpg: { title: 'JPG로 변환', desc: 'PNG, GIF, TIF, SVG, WEBP 등을 JPG로 일괄 변환합니다.' },
    convertFromJpg: { title: 'JPG에서 변환', desc: 'JPG 이미지를 PNG 및 GIF로 변환합니다.' },
    qrCodeGenerator: { title: 'QR 코드 생성기', desc: 'URL, 텍스트, WiFi, 연락처 등을 위한 맞춤형 QR 코드를 생성합니다.' },
    qrCodeScanner: { title: 'QR 코드 스캐너', desc: '카메라나 이미지 업로드로 QR 코드를 즉시 스캔합니다.' },
    blurFace: { title: '얼굴 블러', desc: '개인정보 보호를 위해 이미지의 얼굴을 자동으로 감지하고 블러 처리합니다.' },
    removeBackground: { title: '배경 제거', desc: '높은 정확도로 이미지 배경을 빠르게 제거합니다.' },
    watermarkImage: { title: '워터마크', desc: '몇 초 만에 이미지에 워터마크를 추가합니다.' },
  },

  whyChoose: {
    label: '왜 선택해야 할까요',
    heading: '이미지 편집의 더 스마트한 방법',
    subheading: '전 세계 수천 명의 크리에이터, 디자이너, 개발자가 신뢰합니다.',
    reasons: {
      fast: { title: '번개처럼 빠른 속도', desc: '모든 처리가 브라우저에서 직접 이루어집니다. 외부 서버 업로드 없음.' },
      private: { title: '100% 안전하고 개인적', desc: '파일이 기기를 벗어나지 않습니다. 이미지를 저장하거나 공유하지 않습니다.' },
      noLimits: { title: '제한 없음, 회원가입 없음', desc: '원하는 만큼 모든 도구를 사용하세요 — 완전 무료.' },
      quality: { title: '전문가 수준의 품질', desc: '알고리즘이 전문가 수준의 결과를 제공합니다.' },
      batch: { title: '일괄 처리', desc: '여러 파일을 한 번에 처리합니다.' },
      everywhere: { title: '어디서나 작동', desc: '데스크톱, 태블릿, 모바일에서 완벽하게 작동합니다.' },
    },
    stats: {
      imagesProcessed: '처리된 이미지',
      countriesServed: '서비스 국가',
      uptime: '가동 시간',
      freeTools: '무료 도구',
    },
  },

  footer: {
    tagline: '무료 온라인 이미지 도구 — 몇 초 만에 이미지를 변환, 압축, 크기 조정, 자르기, 편집합니다.',
    imageTools: '이미지 도구',
    moreTools: '더 많은 도구',
    company: '회사',
    contact: '문의',
    allRightsReserved: '모든 권리 보유.',
    privacyPolicy: '개인정보 처리방침',
    termsOfService: '서비스 약관',
  },

  faq: {
    badge: 'FAQ',
    heading: '자주 묻는 질문',
    subheading: '이 도구에 대한 일반적인 질문에 대한 빠른 답변.',
    stillHaveQuestions: '아직 질문이 있으신가요? 도움을 드리겠습니다!',
    reachOut: '팀에 문의하기',
    questionHeader: '질문',
  },

  contactForm: {
    badge: '문의하기',
    title: '문의하기',
    subtitle: '언제든지 메시지를 보내주세요!',
    nameLabel: '이름',
    namePlaceholder: '성명 전체',
    emailLabel: '이메일',
    emailPlaceholder: 'you@example.com',
    subjectLabel: '제목',
    subjectPlaceholder: '어떤 내용인가요?',
    messageLabel: '메시지',
    messagePlaceholder: '여기에 메시지를 작성해 주세요…',
    errName: '이름을 입력해 주세요',
    errEmail: '이메일을 입력해 주세요',
    errEmailInvalid: '유효한 이메일을 입력해 주세요',
    errSubject: '제목을 입력해 주세요',
    errMessage: '메시지를 입력해 주세요',
    sending: '전송 중…',
    send: '메시지 보내기',
    successTitle: '메시지가 전송되었습니다!',
    successMsg: '연락해 주셔서 감사합니다. 곡 답변드리겠습니다.',
    sendAnother: '다른 메시지 보내기',
    sendError: '문제가 발생했습니다. 다시 시도해 주세요.',
  },

  about: {
    label: '소개',
    heading: '크리에이터를 위한, 크리에이터에 의한',
    subheading: '강력한 이미지 도구는 무료이고 빠르며 모든 사람에게 접근 가능해야 한다고 믿습니다.',
    missionTitle: '우리의 미션',
    missionText: 'photremium.com는 단순한 목표로 만들어졌습니다: 웹에서 가장 직관적이고 빠르며 안전한 이미지 편집 경험을 제공하는 것.',
    privacyTitle: '개인정보 우선',
    privacyText: '이미지를 원격 서버에 업로드, 저장하거나 처리하지 않습니다. 모든 것이 기기에 남아 있습니다.',
    techTitle: '최신 기술',
    techText: 'WebAssembly, Canvas API, 최신 React를 포함한 최첨단 웹 기술로 제작되었습니다.',
    communityTitle: '커뮤니티 주도',
    communityText: '모든 기능은 실제 사용자 피드백에서 영감을 받습니다.',
    globalTitle: '글로벌 도달',
    globalText: '120개 이상의 국가에서 크리에이터들이 사용합니다.',
  },

  seo: {
    homeTitle: 'photremium.com — 무료 온라인 이미지 변환기, 압축기 및 편집기',
    homeDesc: '무료로 온라인에서 이미지를 변환, 압축, 크기 조정, 자르기, 편집합니다.',
    homeKeywords: '이미지 변환기, 이미지 압축기, 이미지 크기 조정, 이미지 자르기, 사진 편집기',
    aboutTitle: 'photremium.com 소개 — 우리의 미션',
    aboutDesc: 'photremium.com에 대해 알아보세요. 수백만 명이 신뢰하는 무료 온라인 이미지 도구킷.',
    aboutKeywords: 'photremium.com 소개, 이미지 도구, 무료 이미지 편집기',
  },

        privacyPolicyPage: {
    seo: {
      title: '개인 정보 보호 정책 — Photremium | 서버 업로드 없음, 데이터 저장 없음',
      description: 'Photremium의 개인정보 보호정책은 당사가 귀하의 개인정보를 보호하는 방법을 설명합니다. 모든 이미지 처리는 브라우저에서 100% 이루어집니다. 서버에 파일이 업로드되지 않으며, 개인 데이터가 수집되지 않으며, 추적되지 않습니다.',
      ogTitle: '개인 정보 보호 정책 — Photremium | 업로드 없음, 저장 공간 없음',
      ogDescription: '파일은 기기에 그대로 유지됩니다. Photremium은 서버 접속이나 데이터 저장, 추적 없이 브라우저에서 로컬로 모든 이미지를 처리합니다.',
      twitterTitle: '개인정보 보호정책 — Photremium',
      twitterDescription: '100% 브라우저 기반 이미지 도구입니다. 업로드, 저장, 추적이 없습니다. 개인 정보 보호 정책 전문을 읽어보세요.',
      schemaName: '개인 정보 보호 정책 - Photremium',
      schemaDescription: 'Photremium 개인 정보 보호 정책 - 서버 업로드 없음, 데이터 저장 없음, 100% 브라우저 내 이미지 처리.'
    },
    hero: {
      badge: '개인 정보 보호 정책',
      titlePrefix: '귀하의 개인정보는 우리의 것입니다',
      titleHighlight: '최우선 순위',
      subPrefix: 'photremium.com은 간단한 원칙을 바탕으로 구축되었습니다.',
      subStrong: '파일이 장치를 떠나지 않습니다',
      subSuffix: '이 사이트의 모든 이미지 도구는 전적으로 귀하의 브라우저 내에서 실행됩니다. 업로드가 없습니다. 클라우드가 없습니다. 타협은 없습니다.',
      effectiveLabel: '효과적인',
      lastUpdatedLabel: '마지막 업데이트',
      worldwideLabel: '전 세계적으로 적용됩니다'
    },
    trustCards: [
      {
        title: '서버 업로드 없음',
        desc: '귀하의 파일은 절대로 장치를 떠나지 않습니다. 모든 처리는 100% 브라우저 내에서 이루어집니다.'
      },
      {
        title: '제로 데이터 스토리지',
        desc: '우리는 귀하, 귀하의 이미지 또는 활동에 대해 아무것도 저장하지 않습니다.'
      },
      {
        title: '추적 없음',
        desc: '행동 추적, 지문 채취, 프로파일링이 없습니다.'
      },
      {
        title: 'GDPR 친화적',
        desc: '처음부터 글로벌 개인 정보 보호 규정을 존중하도록 설계되었습니다.'
      }
    ],
    contentsTitle: '내용물',
    toc: {
      overview: '개요',
      'no-upload': '서버 처리 없음',
      'data-collect': '우리가 수집하는 데이터',
      cookies: '쿠키 및 저장',
      'third-party': '제3자 서비스',
      analytics: '해석학',
      children: '아동의 개인정보 보호',
      rights: '귀하의 권리',
      security: '보안',
      changes: '정책 변경',
      contact: '문의하기'
    },
    sections: {
      overview: {
        title: '1. 개요',
        subtitle: '이 정책이 다루는 내용',
        p1Prefix: '본 개인정보 보호정책은 다음과 같은 방법을 설명합니다.',
        p1Middle: '("당사", "당사" 또는 "당사")는 더 정확하게는 다음을 처리합니다.',
        p1Italic: '처리하지 않습니다',
        p1Suffix: '당사의 무료 온라인 이미지 도구를 사용할 때 귀하의 개인정보',
        p2: '처리를 위해 파일을 원격 서버로 보내는 기존 웹 애플리케이션과 달리 photremium.com은 최신 브라우저 API(Canvas API, WebAssembly, WebWorkers)를 사용하여 장치에서 로컬로 모든 작업을 수행합니다. 결과적으로 데이터 전송, 저장, 위험이 없습니다.',
        calloutLabel: '일반 영어 요약:',
        calloutText: '우리는 귀하의 이미지를 볼 수 없고 볼 수도 없으며, 우리의 기술은 결코 볼 수 없도록 특별히 설계되었습니다.'
      },
      noUpload: {
        title: '2. 서버 처리가 전혀 이루어지지 않습니다.',
        subtitle: '우리 도구가 실제로 작동하는 방식',
        introPrefix: 'photremium.com의 모든 도구(이미지 변환기, 압축기, 크기 조정 도구, 배경 제거 도구, 얼굴 흐림 효과, 워터마크, 자르기 및 QR 코드 도구)는 파일을 처리합니다.',
        introStrong: '100% 웹 브라우저 내부',
        introSuffix: '클라이언트 측 JavaScript 및 WebAssembly를 사용합니다.',
        points: [
          {
            label: '파일 업로드가 발생하지 않습니다.',
            text: '파일을 선택하면 브라우저의 파일 API가 해당 파일을 읽고 메모리에서 처리하며 네트워크를 통해 전송되지 않습니다.'
          },
          {
            label: '어떤 서버도 이미지를 수신하지 않습니다.',
            text: '당사의 CDN은 파일이 아닌 앱을 실행하는 데 필요한 HTML, CSS 및 JavaScript 자산만 제공합니다.'
          },
          {
            label: '임시 저장 공간이 없습니다.',
            text: '처리된 결과는 브라우저 메모리에만 존재하며 페이지를 닫거나 다른 곳으로 이동할 때 해제됩니다.'
          },
          {
            label: '오프라인으로 작동합니다.',
            text: '대부분의 도구는 초기 페이지 로드 후 인터넷 연결 없이도 계속 작동합니다. 이는 서버가 관련되지 않는다는 추가 증거입니다.'
          }
        ],
        callout: '직접 확인할 수 있습니다. 개발자 도구에서 브라우저의 네트워크 탭을 열고 이미지를 선택한 다음 파일 데이터가 외부 서버로 전송되지 않는지 확인하세요.'
      },
      dataCollect: {
        title: '3. 당사가 수집하는 데이터(및 수집하지 않는 데이터)',
        subtitle: '데이터 관행에 대한 완전한 투명성',
        headers: {
          type: '데이터 유형',
          collected: '모은?',
          whereWhy: '어디서 / 왜'
        },
        rows: [
          {
            type: '귀하의 이미지 / 파일',
            badge: '절대',
            variant: '녹색',
            showX: true,
            whereWhy: '귀하의 브라우저에서 완전히 처리되며 전송되지 않습니다.'
          },
          {
            type: '이름 / 이메일 주소',
            badge: '절대',
            variant: '녹색',
            showX: true,
            whereWhy: '도구를 사용하기 위해 계정이나 가입이 필요하지 않습니다'
          },
          {
            type: 'IP 주소',
            badge: '최소한의',
            variant: '회색',
            showX: false,
            whereWhy: '표준 웹 서버 로그는 ID와 연결되지 않고 30일 미만으로 보관됩니다.'
          },
          {
            type: '브라우저 / OS 유형',
            badge: '최소한의',
            variant: '회색',
            showX: false,
            whereWhy: '귀하의 브라우저에서 자동으로 전송됩니다. 호환성을 위해서만 사용됨'
          },
          {
            type: '방문한 페이지/클릭수',
            badge: '집계된',
            variant: '파란색',
            showX: false,
            whereWhy: '익명 분석만 가능(개인 식별 불가)'
          },
          {
            type: '언어 환경설정',
            badge: '로컬 전용',
            variant: '파란색',
            showX: false,
            whereWhy: '기기의 localStorage에 저장되었으나 우리에게 전송되지 않았습니다.'
          },
          {
            type: '결제/금융 데이터',
            badge: '절대',
            variant: '녹색',
            showX: true,
            whereWhy: 'photremium.com은 결제가 필요 없이 완전 무료입니다.'
          }
        ]
      },
      cookies: {
        title: '4. 쿠키 및 로컬 저장소',
        subtitle: '기기에 저장되는 내용',
        intro: 'photremium.com은 광고 쿠키, 사이트 간 추적 쿠키 및 제3자 쿠키를 사용하지 않습니다. 우리가 사용하는 유일한 브라우저 저장 공간은 필수 사이트 기능을 위한 것입니다.',
        points: [
          {
            label: '언어 환경설정',
            text: '사이트가 방문할 때마다 선호하는 언어를 기억할 수 있도록 localStorage에 저장됩니다. 우리 서버로 전송되지 않았습니다.'
          },
          {
            label: '테마/UI 환경설정',
            text: '디스플레이 기본 설정을 지정하면 해당 내용은 장치에만 로컬로 저장됩니다.'
          },
          {
            label: '세션 쿠키가 없습니다.',
            text: 'photremium.com에는 로그인 시스템이 없으므로 세션 ID 쿠키가 기록되지 않습니다.'
          }
        ],
        callout: '브라우저 설정(설정 -> 개인정보 보호 -> 검색 데이터 지우기 -> 캐시된 데이터 및 쿠키)을 통해 언제든지 photremium.com 로컬 저장소를 모두 지울 수 있습니다. 그렇게 해도 도구 사용 능력에는 아무런 영향이 없습니다.'
      },
      thirdParty: {
        title: '5. 제3자 서비스',
        subtitle: '우리가 사용하는 외부 서비스와 그 이유',
        intro: 'photremium.com은 인프라와 성능을 위해 엄격하게 신뢰할 수 있는 최소한의 제3자 서비스 세트를 사용합니다. 이러한 서비스 중 어느 것도 귀하의 이미지나 개인 식별 정보를 수신하지 않습니다.',
        headers: {
          service: '서비스',
          purpose: '목적',
          dataShared: '데이터 공유',
          privacyPolicy: '개인 정보 보호 정책'
        },
        rows: [
          {
            service: 'Cloudflare 페이지',
            purpose: '사이트 자산의 호스팅 및 CDN 제공',
            dataShared: 'IP 주소, HTTP 헤더(표준)',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: '멋진 글꼴',
            purpose: 'CDN에서 로드된 아이콘 글꼴',
            dataShared: 'IP 주소(CSS 요청에만 해당)',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: '구글 글꼴',
            purpose: '서체 로딩(해당되는 경우)',
            dataShared: 'IP 주소(글꼴 요청에만 해당)',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: '당사는 위에 나열된 인프라 제공업체 이외의 광고주, 데이터 브로커 또는 기타 제3자와 귀하의 데이터를 공유하지 않습니다.'
      },
      analytics: {
        title: '6. 분석',
        subtitle: '개인정보를 보호하는 집계된 사용 데이터',
        introPrefix: '인기 있는 도구와 사이트 개선 방법을 이해하기 위해 당사는 다음과 같은 정보를 수집할 수 있습니다.',
        introStrong: '집계, 익명 처리',
        introSuffix: '다음과 같은 사용 통계:',
        points: [
          '도구당 페이지 조회수(사용자 식별 없음)',
          '추천 소스(예: Google 검색, 직접 링크) — 개인 데이터 없음',
          '국가 수준의 지리 데이터(도시 또는 정확한 위치 아님)',
          '호환성 분석을 위한 브라우저/기기 유형'
        ],
        calloutLabel: '귀하와 개인적으로 연결된 데이터는 없습니다.',
        calloutText: '우리는 Google Analytics나 Meta Pixel을 사용하지 않습니다. 우리가 사용하는 모든 분석은 개인 정보 보호를 최우선으로 하는 도구입니다(예: 그럴듯하거나 유사한 도구).'
      },
      children: {
        title: '7. 아동의 개인정보 보호',
        subtitle: 'COPPA 및 아동 안전 규정 준수',
        p1: 'photremium.com은 13세(또는 GDPR에 따라 유럽 연합의 경우 16세) 미만 어린이로부터 고의로 개인 정보를 수집하지 않습니다. 우리는 어떤 사용자로부터도 개인 데이터를 수집하지 않기 때문에 어린 사용자가 특별히 할 일은 없습니다. 이 사이트는 모든 사람에게 동등하게 안전합니다.',
        p2Prefix: '아동이 당사 문의 양식을 통해 개인정보를 제출했다고 생각되면 즉시 다음 주소로 연락해 주십시오.',
        p2Suffix: '그리고 즉시 삭제하겠습니다.'
      },
      rights: {
        title: '8. 귀하의 권리',
        subtitle: 'GDPR, CCPA 및 글로벌 개인 정보 보호 권리',
        intro: 'photremium.com은 개인 식별 정보를 수집하지 않기 때문에 대부분의 데이터 주체 권리는 사소하게 적용됩니다. 즉, 액세스, 수정 또는 삭제할 귀하에 관한 데이터가 없습니다. 그럼에도 불구하고 우리는 다음 권리를 전적으로 인정하고 존중합니다.',
        points: [
          {
            label: '접근할 권리',
            text: '귀하는 당사가 귀하에 대해 보유하고 있는 모든 데이터의 사본을 요청할 수 있습니다. (익명화된 로그 외에는 아무것도 없습니다.)'
          },
          {
            label: '정정할 권리',
            text: '귀하는 부정확한 개인정보에 대한 정정을 요청할 수 있습니다.'
          },
          {
            label: '삭제할 권리("잊혀질 권리")',
            text: '귀하는 당사가 보유하고 있는 모든 개인 데이터의 삭제를 요청할 수 있습니다(GDPR 제17조, CCPA).'
          },
          {
            label: '반대/거부할 권리',
            text: '귀하는 브라우저 수준의 거부 또는 광고 차단 도구를 사용하여 향후 분석 수집을 거부할 수 있습니다.'
          },
          {
            label: '데이터 이동성에 대한 권리',
            text: '모든 작업은 장치에 직접 다운로드되므로 내보내기 요청이 필요하지 않습니다.'
          }
        ],
        callout: '이러한 권리는 관할권에 관계없이 전 세계 모든 사용자에게 적용됩니다. 당사는 가장 높은 기준(GDPR)을 기준으로 적용합니다.'
      },
      security: {
        title: '9. 보안',
        subtitle: '귀하의 경험을 보호하는 방법',
        intro: '가장 안전한 데이터는 절대 수집되지 않는 데이터입니다. photremium.com 클라이언트 측 아키텍처는 귀하의 파일이 당사 서버에 없기 때문에 서버 위반으로 인해 귀하의 파일이 노출될 수 없음을 의미합니다. 추가 보안 조치에는 다음이 포함됩니다.',
        points: [
          {
            label: 'HTTPS 시행',
            text: '귀하의 브라우저와 CDN 간의 모든 트래픽은 HSTS가 포함된 TLS 1.2+를 통해 암호화됩니다.'
          },
          {
            label: '콘텐츠 보안 정책(CSP)',
            text: '엄격한 헤더는 크로스 사이트 스크립팅과 인라인 스크립트 삽입을 방지합니다.'
          },
          {
            label: '정기적인 종속성 감사',
            text: '우리는 알려진 취약점을 패치하기 위해 정기적으로 npm 패키지를 감사하고 업데이트합니다.'
          }
        ],
        disclosurePrefix: '책임있는 공개',
        disclosureTextPrefix: '보안 문제를 발견하셨나요? 이메일을 보내주세요',
        disclosureTextSuffix: '48시간 이내에 응답해 드리겠습니다.'
      },
      changes: {
        title: '10. 본 정책의 변경 사항',
        subtitle: '정책 업데이트를 처리하는 방법',
        intro: '당사는 당사의 관행, 도구 또는 법적 요구 사항의 변경 사항을 반영하기 위해 수시로 본 개인 정보 보호 정책을 업데이트할 수 있습니다. 우리가 할 때:',
        points: [
          {
            label: '"최종 업데이트"',
            text: '페이지 상단의 날짜가 수정될 예정입니다.'
          },
          {
            label: '소재 변경',
            text: '최소 30일 동안 홈페이지에 눈에 띄는 공지를 통해 전달됩니다.'
          },
          {
            label: '이전 버전',
            text: '본 정책의 내용은 요청 시 보관되어 제공됩니다.'
          }
        ],
        outro: '변경 사항이 게시된 후에도 photremium.com을 계속 사용하면 업데이트된 정책을 수락하는 것으로 간주됩니다. 이 페이지를 정기적으로 검토하는 것이 좋습니다.'
      },
      contact: {
        title: '11. 연락처 및 데이터 요청',
        subtitle: '개인정보 보호에 관해 문의하기',
        p1Prefix: '본 개인정보 보호정책과 관련된 질문, 우려 사항 또는 공식적인 데이터 요청이 있는 경우 당사에 문의하십시오. 당사는 모든 개인정보 보호 관련 문의에 대해',
        p1Strong: '영업일 기준 5일'
      }
    },
    footer: {
      privacyQuestionsTitle: '개인정보 보호에 관해 질문이 있으신가요?',
      privacyQuestionsDesc: '개인 정보 보호 관련 질문, 데이터 요청 또는 우려 사항을 보내주시면 즉시 답변해 드리겠습니다.',
      versionHistoryTitle: '버전 기록',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
/* ————— Common / shared UI strings ————— */
  common: {
    new: '새로운!',
    download: '다운로드',
    downloadAll: '모두 다운로드',
    downloadAs: '다운로드 형식:',
    zip: 'ZIP',
    separate: '개별',
    upload: '업로드',
    dragDrop: '이미지를 여기에 끌어다 놓거나 클릭하여 찾아보기',
    remove: '제거',
    reset: '초기화',
    apply: '적용',
    cancel: '취소',
    clear: '지우기',
    close: '닫기',
    save: '저장',
    processing: '처리 중...',
    noFiles: '선택된 파일 없음',
    selectFiles: '파일 선택',
    or: '또는',
    browseFiles: '파일 탐색',
    dropHere: '이미지를 여기에 놓으세요',
    chooseFiles: '파일 선택',
    pasteHint: '이미지를 붙여넣을 수도 있습니다',
    quality: '품질',
    width: '너비',
    height: '높이',
    format: '형식',
    compression: '압축',
    preview: '미리보기',
    original: '원본',
    result: '결과',
    before: '이전',
    after: '이후',
    startOver: '다시 시작',
    startOverConfirm: '모든 이미지를 제거하고 다시 시작하시겠습니까?',
    addMoreImages: '이미지 추가',
    addImage: '이미지 추가',
    images: '이미지',
    totalSize: '전체 크기',
    size: '크기',
    type: '유형',
    unsavedEdits: '저장되지 않은 편집이 있습니다. 이 페이지를 떠나시겠습니까?',
    compareSlider: '비교 슬라이더',
    toggleToolsPanel: '도구 패널 전환',
    closePanel: '패널 닫기',
    zoomIn: '확대',
    zoomOut: '축소',
    fit: '맞춤',
    none: '없음',
  },

  compressor: {
    seo: {
      uploadTitle: '이미지 압축기 — JPG, PNG, SVG, GIF 무료 압축 | photremium.com',
      uploadDesc: 'JPG, PNG, SVG, GIF 이미지를 무료로 온라인 압축. 품질을 유지하면서 파일 크기를 최대 80%까지 축소.',
      uploadKeywords: '이미지 압축기, jpg 압축, png 압축, 이미지 크기 줄이기',
      workspaceTitle: '이미지 압축 중 — photremium.com 이미지 압축기',
      workspaceDesc: '압축 수준을 조정하고 최적화된 이미지를 다운로드하세요.',
      workspaceKeywords: '이미지 압축, 이미지 최적화',
    },
    title: '이미지 압축기',
    desc: 'JPG, PNG, GIF 이미지를 최대 80%까지 압축. 빠르고 안전합니다.',
    toCompress: '압축할',
    compressionForAll: '모든 이미지의 압축',
    summary: '요약',
    originalSize: '원본 크기',
    compressed: '압축됨',
    saved: '절약됨',
    compressionLabel: '압축:',
    compressing: '압축 중…',
    compressDownload: '압축 및 다운로드',
    lowQualityWarning: '압축률이 높으면 이미지 선명도가 크게 저하될 수 있습니다.',
    blog: {
      tocTitle: '목차',
      title: '이미지 압축 블로그',
      formatsIntro: '우리 도구는 모든 이미지 형식을 지원하므로 어떤 이미지든 원활하게 압축할 수 있습니다. 지원 형식 전체 목록은 아래와 같습니다:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. 이미지 압축기란?',
          paragraphs: [
            '이미지 압축기는 이미지의 시각적 품질을 최대한 유지하면서 파일 크기를 줄여 주는 소프트웨어 또는 온라인 서비스입니다. 다만 압축을 과도하게 하면 품질 저하가 눈에 띌 수 있습니다.',
          ],
          listTitle: '유형:',
          bullets: [
            '손실 압축: 일부 이미지 데이터를 제거해 파일 크기를 줄입니다. 품질이 낮아질 수 있지만, 낮은 수준에서는 사람의 눈으로 크게 느끼기 어렵습니다.',
            '무손실 압축: 이미지의 시각적 품질을 유지한 채 파일 크기만 줄입니다.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. 왜 우리 도구를 선택해야 할까요?',
          bullets: [
            'AI 기반 이미지 압축 도구가 모든 기기에서 안정적으로 동작하며 최상의 결과를 제공합니다.',
            '한 번의 클릭으로 여러 이미지(100장 이상도 가능)를 동시에 압축할 수 있습니다.',
            '이미지를 서버에 업로드할 필요가 없습니다. 모든 처리는 브라우저 로컬에서 진행됩니다.',
            '우리 이미지 압축 도구는 영구적으로 무료이며, 친구와 공유해도 됩니다.',
            '원하는 압축 비율을 직접 선택할 수 있습니다.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. 단계별 가이드',
          steps: [
            {
              heading: '1. 압축할 이미지를 선택하세요.',
              bullets: [
                '이미지를 드래그 앤 드롭으로 업로드 박스에 넣으세요.',
                '이미지를 복사한 뒤 (Ctrl + V)로 박스에 붙여넣을 수도 있습니다.',
                '선택 버튼을 눌러 파일 탐색기에서 불러올 수도 있습니다.',
              ],
            },
            {
              heading: '2. 압축 비율을 선택하세요.',
              bullets: [
                '가로 슬라이더로 압축 비율을 편하게 선택할 수 있습니다. 정확한 결과를 위해 아래 범위를 참고하세요.',
              ],
              table: {
                headers: ['압축 비율', '결과'],
                rows: [
                  ['1%  ~  40%', '최고 품질'],
                  ['41%  ~  60%', '일반 품질(권장)'],
                  ['61%  ~  100%', '낮은 품질'],
                ],
              },
            },
            {
              heading: '3. 절약된 용량을 확인하세요.',
              paragraphs: [
                '모든 용량 지표가 실시간으로 표시됩니다. 전체 대비 얼마나 줄었는지 확인하면서, 필요한 파일 크기에 맞게 압축 수준을 조정할 수 있습니다.',
              ],
            },
            {
              heading: '4. 토글 버튼에서 다운로드 옵션을 선택하세요.',
              bullets: [
                'ZIP: 여러 이미지를 압축할 때 표시됩니다. 선택하면 모든 압축 이미지를 하나의 ZIP 파일로 묶어 다운로드합니다(대량 이미지에 권장).',
                '개별 다운로드: ZIP 하나가 아닌, 각 이미지를 개별 파일로 다운로드합니다(소량 이미지, 10장 미만에 권장).',
              ],
            },
            {
              heading: '5. 압축 후 다운로드하세요.',
              paragraphs: [
                '이 버튼을 누르면 선택한 다운로드 방식에 따라 압축된 이미지가 자동으로 내려받아집니다.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. 이미지 압축의 장점.',
          bullets: [
            '저장 비용 절감: 이미지 압축으로 파일 크기가 줄어 저장 공간 비용을 절약할 수 있습니다.',
            '더 빠른 로딩: 압축 이미지는 더 빨리 로드되어 웹사이트/앱 사용자 경험을 개선합니다.',
            'Gmail 첨부 제한 해결: Gmail은 첨부 용량이 25MB로 제한되므로, 압축하면 더 많은 파일을 보낼 수 있습니다.',
            '더 빠른 공유 및 전송: 큰 파일은 전송 시간이 길어지므로, 압축으로 시간과 데이터 사용량을 줄일 수 있습니다.',
            '프레젠테이션 최적화: 비압축 이미지는 발표 파일을 무겁게 만들지만, 압축 이미지는 파일 크기를 크게 줄여줍니다.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. 지원 형식.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: '이미지 변환기 — PNG, JPG, WEBP, GIF, SVG 무료 변환 | photremium.com',
      uploadDesc: 'JPG, PNG, WEBP, GIF, SVG, TIFF, BMP 등 간의 이미지 변환. 무료 온라인 이미지 형식 변환기.',
      uploadKeywords: '이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',
      workspaceKeywords: '이미지 변환, 이미지 형식 변환기',

      routeKeywords: {

        'png-to-jpg': 'png 변환할 jpg, png to jpg, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'jpg-to-png': 'jpg 변환할 png, jpg to png, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'png-to-webp': 'png 변환할 webp, png to webp, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'jpg-to-webp': 'jpg 변환할 webp, jpg to webp, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'webp-to-jpg': 'webp 변환할 jpg, webp to jpg, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'webp-to-png': 'webp 변환할 png, webp to png, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'gif-to-jpg': 'gif 변환할 jpg, gif to jpg, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'gif-to-png': 'gif 변환할 png, gif to png, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'bmp-to-jpg': 'bmp 변환할 jpg, bmp to jpg, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'bmp-to-png': 'bmp 변환할 png, bmp to png, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'svg-to-png': 'svg 변환할 png, svg to png, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'svg-to-jpg': 'svg 변환할 jpg, svg to jpg, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'tiff-to-jpg': 'tiff 변환할 jpg, tiff to jpg, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'tiff-to-png': 'tiff 변환할 png, tiff to png, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'jpg-to-gif': 'jpg 변환할 gif, jpg to gif, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'png-to-gif': 'png 변환할 gif, png to gif, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'jpg-to-bmp': 'jpg 변환할 bmp, jpg to bmp, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'png-to-bmp': 'png 변환할 bmp, png to bmp, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'webp-to-gif': 'webp 변환할 gif, webp to gif, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'jpg-to-ico': 'jpg 변환할 ico, jpg to ico, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'png-to-ico': 'png 변환할 ico, png to ico, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'jpg-to-svg': 'jpg 변환할 svg, jpg to svg, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'png-to-svg': 'png 변환할 svg, png to svg, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'webp-to-svg': 'webp 변환할 svg, webp to svg, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'gif-to-svg': 'gif 변환할 svg, gif to svg, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'bmp-to-svg': 'bmp 변환할 svg, bmp to svg, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

        'tiff-to-svg': 'tiff 변환할 svg, tiff to svg, 이미지 변환기, png를 jpg로, jpg를 png로, webp 변환기',

      },
    },
    title: '이미지 변환기',
    desc: 'JPG, PNG, WEBP, GIF, SVG, TIFF, BMP 등 간에 이미지를 변환합니다. 여러 파일을 일괄 변환.',
    toConvert: '변환할',
    convertSettings: '변환 설정',
    detected: '감지됨',
    convertTo: '변환 대상',
    converting: '변환 중…',
    convertToFormat: '{format}으로 변환',
    popularConversions: '인기 변환',
    convertingTo: '변환 중',
    all: '전체',
  },

  resizer: {
    seo: {
      uploadTitle: '이미지 크기 조정 — JPG, PNG 무료 크기 조정 | photremium.com',
      uploadDesc: '픽셀이나 퍼센트로 이미지 크기를 무료로 온라인 조정.',
      uploadKeywords: '이미지 크기 조정, 이미지 리사이저, jpg 크기 조정, png 크기 조정',
      workspaceTitle: '이미지 크기 조정 중 — photremium.com',
      workspaceDesc: '이미지 크기를 무료로 온라인 조정.',
      workspaceKeywords: '이미지 크기 조정, 리사이저',
    },
    title: '이미지 크기 조정',
    desc: '픽셀, 퍼센트, 센티미터, 인치로 크기를 정의하고 즉시 조정합니다.',
    toResize: '크기 조정할',
    resizeSettings: '크기 조정 설정',
    resizeBy: '크기 조정 기준:',
    byPixels: '픽셀',
    byPercentage: '퍼센트',
    byCentimeters: '센티미터',
    byInches: '인치',
    advanced: '고급',
    lockAspect: '비율 고정',
    unlockAspect: '비율 해제',
    dontEnlarge: '원본이 더 작으면 확대하지 않음',
    resizing: '크기 조정 중…',
    resizeDownload: '크기 조정 및 다운로드',
    blog: {
      tocTitle: '목차',
      title: '이미지 리사이저 블로그',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. 왜 이미지 리사이저를 사용하나요?',
          paragraphs: [
            '이미지 리사이저는 이미지의 크기(치수)를 변경하는 도구/소프트웨어입니다. 높이, 너비 또는 둘 다를 바꿔 원하는 크기로 조정할 수 있습니다. 이미지 업로드/게시 크기 제한이 있는 소셜 미디어 플랫폼에서 특히 유용합니다.',
          ],
          listTitle: '예시:',
          bullets: [
            '인스타그램 게시물: 1080 x 1080px(정사각형)',
            '페이스북 게시물: 1200 x 630px',
            'X(구 트위터) 게시물: 1200 x 675px',
            '인스타그램 스토리: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. 왜 우리 이미지 리사이저 도구를 선택해야 하나요?',
          paragraphs: [
            'AI 기반 이미지 리사이저로 정확하고 매우 빠르게 크기를 조정할 수 있습니다. 어떤 기기에서도 매끄럽게 사용할 수 있으며, 앱 설치/다운로드가 필요 없습니다. 모든 기능은 브라우저에서 온라인으로 제공됩니다.',
          ],
          bullets: [
            '여러 이미지(100장 이상도 가능)를 한 번에 리사이즈할 수 있습니다. 고성능 기기라면 수초 내에 400~500장도 처리할 수 있습니다.',
            '모든 처리는 로컬 브라우저에서 수행됩니다. 이미지를 서버에 업로드할 필요가 없고, 이미지가 기기를 벗어나지 않으므로 개인정보 위험 없이 사용할 수 있습니다.',
            '리사이즈 단위를 여러 가지 지원합니다.',
            '체크박스 선택만으로 리사이즈 후에도 원본 종횡비를 유지할 수 있습니다.',
            '여러 이미지를 리사이즈할 때 개별 다운로드 또는 ZIP 다운로드를 선택할 수 있습니다.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. 단계별 가이드',
          steps: [
            {
              heading: '먼저, 리사이즈할 이미지(여러 장 가능)를 선택합니다. 선택 방법은 여러 가지가 있습니다.',
              bullets: [
                '이미지를 드래그 앤 드롭하여 리사이즈할 수 있습니다.',
                '“Ctrl + V” 단축키로 드롭 박스에 이미지를 붙여넣을 수도 있습니다.',
                '“Choose Files” 버튼을 누르면 파일 탐색기가 열리며 원하는 이미지를 선택할 수 있습니다.',
              ],
            },
            {
              heading: '그다음, 리사이즈 단위를 선택합니다. 현재 제공 단위는 다음과 같습니다:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: '단위를 선택한 후 높이와 너비를 조정해 이미지를 리사이즈합니다. 체크박스로 종횡비를 고정할 수도 있습니다.',
            },
            {
              heading: '원본보다 커지지 않게 하려면 “Don’t enlarge if original is smaller” 체크박스를 선택합니다.',
            },
            {
              heading: '이후 다운로드 옵션을 선택합니다.',
              bullets: [
                '여러 이미지를 하나의 zip 파일로 받고 싶다면 ZIP을 선택하세요.',
                '각 이미지를 따로 받고 싶다면 “separate”를 선택하세요.',
              ],
            },
            {
              heading: '마지막으로 “Resize & Download” 버튼을 눌러 선택한 다운로드 옵션대로 이미지를 받습니다.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. 이미지 리사이즈 도구의 장점: 이 도구의 가장 큰 장점은 웹페이지와 소셜 미디어 게시물에서 이미지를 올바르게 배치할 수 있다는 점입니다.',
          tocLabel: '4. 이미지 리사이즈 도구의 장점',
          bullets: [
            'UX 향상: 올바른 크기와 적절한 이미지 배치는 사용자 경험을 크게 향상시킵니다. 너무 크거나 작은 이미지를 조정 없이 배치하면 UX가 나빠집니다.',
            '소셜 미디어 지원: 여러 소셜 앱은 이미지 게시 크기 제한을 갖고 있습니다. 우리 도구는 필요한 규격에 맞게 이미지를 조정해 줍니다.',
            '반응형 디자인: 개발자가 반응형 디자인을 만들 때, 다양한 기기를 지원하려면 이미지 크기를 여러 규격으로 준비해야 합니다.',
            '최선의 선택: 이미지를 늘리거나 자르면 비율이 깨질 수 있으므로, 리사이즈 도구가 더 좋은 선택입니다.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. 지원 형식: 우리 이미지 리사이저는 어떤 형식의 이미지든 리사이즈 대상으로 선택할 수 있습니다. 지원 형식은 다음과 같습니다:',
          tocLabel: '5. 지원 형식',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: '이미지 자르기 — JPG, PNG, GIF 무료 자르기 | photremium.com',
      uploadDesc: 'JPG, PNG, GIF 이미지를 무료로 쉽게 자르기.',
      uploadKeywords: '이미지 자르기, 이미지 크로퍼, jpg 자르기, png 자르기',
      workspaceTitle: '이미지 자르기 중 — photremium.com',
      workspaceDesc: '이미지를 무료로 온라인 자르기.',
      workspaceKeywords: '이미지 자르기, 크로퍼',
    },
    title: '이미지 자르기',
    desc: '비주얼 편집기로 JPG, PNG, GIF 등을 자릅니다. 미리 설정된 비율 또는 자유형 자르기.',
    toCrop: '자를',
    cropSettings: '자르기 설정',
    widthPx: '너비 (px)',
    heightPx: '높이 (px)',
    positionX: '위치 X (px)',
    positionY: '위치 Y (px)',
    cropTemplate: '자르기 템플릿',
    landscape: '가로',
    portrait: '세로',
    square: '정사각형',
    freeform: '자유형',
    cropping: '자르는 중…',
    cropDownload: '자르기 및 다운로드',
    cropDownloadAll: '모두 자르기 및 다운로드',
    saveNext: '저장 후 다음',
    croppedNofTotal: '{total}개 중 {n}개를 잘랐습니다.',
    downloadN: '{n}개 다운로드',
    blog: {
      tocTitle: '목차',
      title: '이미지 자르기 블로그',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. 왜 이미지 자르기 도구를 사용해야 하나요?',
          paragraphs: [
            '이미지 자르기 도구는 이미지를 원하는 형태로 잘라내는 소프트웨어 도구입니다. 원하는 부분만 남기고 바깥의 불필요한 영역을 제거할 때 널리 사용됩니다. 이 도구는 자르고 싶은 위치에 맞게 조절할 수 있는 크롭 박스를 제공합니다.',
          ],
          listTitle: '예를 들어:',
          bullets: [
            '단체 사진에서 나만 잘라내기.',
            '목록에서 내 이름만 잘라내기.',
            '전체 스크린샷에서 진행 바만 잘라내기.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. 왜 우리 이미지 자르기 도구를 선택해야 하나요?',
          paragraphs: [
            '우리 이미지 자르기 도구는 매우 빠르고 정확하게 이미지를 자를 수 있게 해줍니다. 어떤 이미지든 자르고 싶은 위치에 맞게 크롭 박스 크기만 조절하면 됩니다. 이미지 선택 시 거의 모든 이미지 형식을 지원합니다.',
          ],
          bullets: [
            '기기가 지원하는 만큼 많은 이미지를 자를 수 있습니다. 고성능 기기라면 100장 이상의 이미지도 지연 없이 한 번에 자를 수 있습니다.',
            '이미지는 로컬 브라우저에서 처리됩니다. 서버에 이미지를 업로드할 필요가 없어 이미지가 기기를 벗어나지 않습니다. 개인 이미지도 보안 걱정 없이 자를 수 있습니다.',
            '많은 도구가 이미지 형식 오류를 표시하지만, 우리 도구는 거의 모든 이미지 형식을 지원해 이 문제를 해결합니다.',
            '여러 이미지를 한 번에 자를 때, 잘린 이미지를 ZIP으로 받거나 개별 파일로 받을지 원하는 방식으로 다운로드할 수 있습니다.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. 단계별 가이드',
          steps: [
            {
              heading: '1. 먼저 자를 이미지를 선택하세요. 우리 이미지 자르기 도구는 여러 이미지를 한 번에 선택하는 것도 지원합니다.',
              bullets: [
                '이미지를 드래그 앤 드롭으로 업로드 박스에 넣어 자르세요.',
                '크롭 박스의 choose files 버튼을 클릭해 파일 탐색기에서 이미지를 선택할 수도 있습니다.',
                'Ctrl + V 단축키로 이미지를 업로드 박스에 붙여넣는 것도 지원됩니다.',
              ],
            },
            {
              heading: '2. 그런 다음 이미지 위에서 크롭 박스의 크기와 위치를 조절해 자르세요.',
            },
            {
              heading: '3. 높이, 너비, 가로 위치, 세로 위치 값을 직접 입력해서 크롭 박스를 조절할 수도 있습니다.',
            },
            {
              heading: '4. 다음과 같은 준비된 템플릿도 사용할 수 있습니다:',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. 그다음 다운로드 옵션 중 하나를 선택해야 합니다.',
              bullets: [
                'ZIP: 여러 이미지를 자르고, 잘린 이미지를 하나의 파일로 다운로드하려면 이 옵션을 선택하세요.',
                'Separate: 잘린 이미지를 각각 따로 다운로드하려면 토글 버튼에서 이 옵션을 선택하세요.',
              ],
            },
            {
              heading: '6. 마지막으로 Crop & Download 버튼을 클릭하면 설정한 크기로 잘린 모든 이미지를 다운로드할 수 있습니다.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. 이미지 자르기의 장점: 이미지 자르기 도구는 디지털 환경에서 여러 장점을 제공합니다. 그중 일부는 아래와 같습니다:',
          tocLabel: '4. 이미지 자르기의 장점',
          bullets: [
            '프레임에 이미지 맞추기: 이미지 자르기 도구는 이미지를 프레임 안에 올바르게 배치하는 데 도움이 됩니다. 이 프레임은 웹페이지나 소셜 미디어 플랫폼일 수 있습니다.',
            'UX 향상: 이미지를 올바르게 배치하면 사용자 경험이 향상되므로, 이미지 자르기는 UX 개선에 크게 기여합니다.',
            '불필요한 테두리 제거: 이미지의 불필요한 가장자리를 제거해 더 깔끔하게 만들 수 있습니다.',
            '원하는 대상 분리: 단체 사진에서 원하는 인물만 분리할 수 있습니다.',
            '저장 공간 절약: 이미지의 불필요한 영역이 제거되고 필요한 부분만 저장되므로 저장 공간을 절약할 수 있습니다.',
            '프레젠테이션 최적화: 자르지 않은 이미지 10장이 포함된 일반 프레젠테이션이 약 30MB라면, 같은 내용을 잘린 이미지로 구성하면 약 10MB 정도로 줄일 수 있습니다.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. 지원 형식:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: '온라인 사진 편집기 — 텍스트, 효과, 프레임으로 무료 편집 | photremium.com',
      desc: '온라인에서 무료로 사진 편집 — 텍스트, 효과, 프레임, 스티커 추가. 브라우저에서 실행.',
      keywords: '사진 편집기, 온라인 사진 편집기, 사진 편집 온라인 무료',
    },
    title: '사진 편집기',
    desc: '텍스트, 효과, 프레임, 스티커로 사진을 꾸미세요.',
    toEdit: '편집할',
    textTypography: '텍스트 및 타이포그래피',
    textTypographyDesc: '다양한 폰트, 색상, 그림자, 위치 옵션으로 텍스트를 추가합니다.',
    filtersEffects: '필터 및 효과',
    filtersEffectsDesc: '전문 필터를 적용하고 밝기, 대비, 채도를 조정합니다.',
    framesStickers: '프레임 및 스티커',
    framesStickersDesc: '아름다운 프레임과 재미있는 스티커를 선택하여 이미지를 향상시킵니다.',
  },

  removeBg: {
    seo: {
      uploadTitle: '이미지 배경 무료 제거 | photremium.com',
      uploadDesc: '높은 정확도로 이미지 배경을 빠르게 제거. 무료 온라인 배경 제거기.',
      uploadKeywords: '배경 제거, 배경 제거기, 이미지 배경 제거, 투명 배경',
      workspaceTitle: '배경 제거 중 — photremium.com',
      workspaceDesc: '무료로 온라인에서 이미지 배경 제거.',
      workspaceKeywords: '배경 제거, 투명 배경',
    },
    title: '배경 제거',
    desc: '고급 엣지 감지로 이미지 배경을 즉시 제거. 100% 무료, 브라우저에서 실행.',
    toRemoveBg: '배경을 제거할',
    backgroundRemover: '배경 제거기',
    processingProgress: '처리 진행 상황',
    processingNImages: '{n}개 이미지 처리 중…',
    allNProcessed: '모든 {n}개 이미지 처리 완료!',
    nOfTotalDone: '{n} / {total} 완료',
    fileName: '파일 이름',
    dimensions: '크기',
    status: '상태',
    statusDone: '✓ 완료',
    statusProcessing: '⏳ 처리 중',
    statusError: '✗ 오류',
    statusPending: '⏸ 대기 중',
    badgeDone: '완료',
    badgeProcessing: '처리 중…',
    badgeError: '오류',
    removingBg: '배경 제거 중…',
    retry: '재시도',
    downloading: '다운로드 중…',
    nextImage: '다음 이미지',
  },

  watermark: {
    seo: {
      uploadTitle: '이미지 워터마크 — 텍스트 및 로고 워터마크 무료 추가 | photremium.com',
      uploadDesc: '몇 초 만에 사진에 텍스트 또는 이미지 워터마크를 추가. 무료, 빠름.',
      uploadKeywords: '워터마크 이미지, 워터마크 추가, 텍스트 워터마크',
      workspaceTitle: '이미지 워터마크 — photremium.com',
      workspaceDesc: '무료로 온라인에서 이미지에 워터마크 추가.',
      workspaceKeywords: '워터마크 이미지, 워터마크 추가',
    },
    title: '워터마크 이미지',
    desc: '이미지에 텍스트 또는 로고 워터마크를 추가합니다. 폰트, 불투명도, 크기, 위치를 사용자 정의.',
    toWatermark: '워터마크 추가할',
    watermarkTools: '워터마크 도구',
    addText: '텍스트 추가',
    addImage: '이미지 추가',
    layersN: '레이어 ({n})',
    noLayers: '아직 추가된 레이어 없음',
    textLayer: '텍스트 레이어',
    imageLayer: '이미지 레이어',
    watermarkDownloadAll: '워터마크 적용 후 모두 다운로드',
    watermarkDownload: '워터마크 적용 후 다운로드',
    nextImage: '다음 이미지',
    selectToEdit: '편집을 시작하려면 이미지나 텍스트를 선택하세요',
    bold: '굵게',
    italic: '기울임',
    underline: '밑줄',
    bgColor: '배경 색상',
    textColor: '텍스트 색상',
    alignLeft: '왼쪽 정렬',
    alignCenter: '가운데 정렬',
    alignRight: '오른쪽 정렬',
    opacity: '불투명도',
    stroke: '획',
    strokeWidth: '획 너비',
    strokeColor: '획 색상',
    tileRepeat: '타일 / 반복',
    tilePattern: '타일 패턴',
    spacing: '간격',
    snapToCenter: '가운데에 스냅',
    duplicate: '복제',
    delete: '삭제',
    flipHorizontal: '수평 뒤집기',
    flipVertical: '수직 뒤집기',
    rotateLeft: '왼쪽으로 회전',
    rotateRight: '오른쪽으로 회전',
    cornerRadius: '모서리 반경',
    borderStroke: '테두리 / 획',
    borderWidth: '테두리 너비',
    color: '색상',
    style: '스타일',
    hide: '숨기기',
    show: '표시',
    lock: '잠금',
    unlock: '잠금 해제',
    solid: '실선',
    dashed: '파선',
    dotted: '점선',
    double: '이중선',
    tileSingle: '단일',
    tile2x2: '2×2 그리드',
    tile3x3: '3×3 그리드',
    removeAllConfirm: '모든 이미지와 워터마크를 제거하시겠습니까?',
    dimMismatch: '업로드된 이미지의 크기가 다릅니다. 최상의 결과를 위해 동일한 해상도의 이미지를 업로드하세요.',
    clearBackground: '배경 지우기',
    typeHere: '여기에 입력...',
    linkCorners: '모서리 연결',
    separateCorners: '모서리 분리',
    blog: {
      tocTitle: '목차',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: '워터마크 도구 개요',
          title: '이미지에 온라인으로 워터마크를 추가하는 방법 — Photremium 워터마크 도구 완전 가이드',
          paragraphs: [
            '방금 아름다운 사진 편집을 마쳤습니다. 매장용 제품 사진일 수도 있고, 고객 촬영에서 나온 인물 사진일 수도 있으며, 수시간을 들여 완성한 디지털 아트일 수도 있습니다. 그리고 이제 모든 창작자가 결국 마주하게 되는 질문이 찾아옵니다. 공유하기 전에 어떻게 보호할 것인가?',
            '대부분의 전문가가 선택하는 답은 워터마크입니다. 그리고 그럴 만한 이유가 있습니다. 적절히 배치된 워터마크는 작품에 영구적인 서명처럼 작용해 추적 가능하고, 브랜드를 드러내며, 훨씬 더 훔치기 어렵게 만듭니다.',
            '많은 사람이 부딪히는 문제는 간단합니다. 온라인에서 쓸 수 있는 도구가 너무 불편하거나, 구독 뒤에 잠겨 있거나, 워터마크가 너무 무거워 이미지 전체를 망쳐 버립니다.',
            'Photremium의 Watermark Image 도구는 이 모든 문제를 해결하기 위해 만들어졌습니다. 완전히 브라우저 기반이며, 무료이고, 계정이 필요 없는 워터마크 작업 공간으로, 파일을 서버에 업로드하지 않고도 브라우저 안에서 바로 작동합니다. 모든 것은 로컬에 남고, 모든 것은 빠르게 처리되며, 제공되는 창작 제어 수준은 데스크톱 소프트웨어에 기대하는 수준에 필적합니다. 이 가이드에서는 어떻게 작동하는지, 누구를 위해 만들어졌는지, 그리고 매번 최고의 결과를 얻는 방법을 정확히 보여드립니다.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: '워터마크란 무엇인가',
          title: '워터마크란 무엇이며 왜 중요한가?',
          paragraphs: [
            '도구 자체로 들어가기 전에, 워터마크가 무엇을 하는지와 왜 많은 사진가, 디자이너, 콘텐츠 제작자들이 이것을 필수라고 여기는지 이해하는 것이 좋습니다.',
            '워터마크는 이미지에 추가되는 보이는 오버레이로, 보통 텍스트, 로고, 또는 저작권 기호가 사용되며 창작자나 소유자를 식별합니다. 메타데이터처럼 파일 안에 숨겨져 몇 초 만에 제거될 수 있는 것이 아니라, 워터마크는 이미지 자체에 시각적으로 내장됩니다. 우클릭만으로는 눈에 띄는 품질 저하 없이 제거할 수 없습니다.',
          ],
          subSections: [
            {
              title: '창작자가 워터마크를 사용하는 이유',
              paragraphs: [
                '이미지에 워터마크를 넣는 실용적인 이유는 세 가지 핵심 문제로 귀결됩니다.',
              ],
              bullets: [
                '소유권 식별. 작품이 소셜 미디어, Pinterest 보드, 블로그 글에 퍼져 나가면 원래의 출처 표기는 자주 사라집니다. 워터마크는 이미지가 어디로 가든 당신의 이름이나 브랜드가 함께 따라가게 해 줍니다.',
                '도용 억제. 대부분의 가벼운 이미지 도둑은 가장 쉬운 경로를 찾습니다. 보기 좋고, 잘 배치되어 있으며, 약간 투명한 전문적인 워터마크는 이 이미지는 자신의 작업을 소중히 여기는 사람의 것이라는 분명한 신호를 보냅니다.',
                '클라이언트 포트폴리오 보호. 최종 결제 전 미리보기를 공유하는 사진가는 고객이 청구서를 해결하기 전에 미리보기를 사용하는 것을 막기 위해 워터마크를 자주 사용합니다. 은은한 워터마크는 미리보기 평가를 방해하지 않으면서 이 목적을 달성합니다.',
              ],
            },
            {
              title: '누가 이미지에 워터마크를 넣어야 하는가',
              paragraphs: [
                '다음 범주 중 하나라도 해당한다면, 온라인에 공유하기 전에 이미지를 워터마크하는 것은 선택이 아니라 필수입니다.',
              ],
              bullets: [
                '고객과 갤러리를 공유하는 프리랜서 사진가',
                '포트폴리오 샘플을 배포하는 그래픽 디자이너',
                '라이선스 계약 전에 제품 사진을 보여 주는 이커머스 판매자',
                '소셜 플랫폼에서 작품을 공유하는 디지털 아티스트',
                '이미지가 자주 재사용되는 블로거와 콘텐츠 제작자',
                '인지도 있는 브랜드를 구축하는 스톡 사진 제공자',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: '작업 공간 패널',
          title: 'Photremium 워터마크 도구 내부: 실제 작업 흐름을 위해 설계된 3패널 작업 공간',
          paragraphs: [
            'Photremium 워터마크 도구가 기본적인 온라인 워터마커와 다른 점은 작업 공간 디자인입니다. 단순히 “텍스트 입력, 위치 선택, 완료” 방식이 아니라, 전문 디자인 소프트웨어에서 볼 수 있는 형태를 닮은 3패널 레이아웃을 제공합니다. 다만 완전히 브라우저에서 작동하며 설치가 필요하지 않습니다.',
          ],
          subSections: [
            {
              title: '왼쪽 canvas 패널',
              paragraphs: [
                'canvas 패널은 화면의 가장 큰 부분을 차지하며 워터마크가 적용된 이미지가 실시간으로 어떻게 보이는지 정확하게 보여 줍니다. 불투명도 조정, 텍스트 레이어 재배치, 로고 크기 조정 등 모든 변경 사항이 즉시 canvas에 반영됩니다. 미리보기 버튼을 누를 필요가 없습니다. 보이는 그대로 결과가 됩니다.',
                'canvas에는 확대/축소 도구 모음도 내장되어 있어 정밀 정렬을 위해 확대하고 전체 그림을 보기 위해 축소할 수 있습니다. 화면 맞춤 기능은 화면 크기를 기준으로 최적의 초기 스케일을 자동 계산하므로, 고해상도 이미지도 편안한 작업 크기로 열립니다. 이미지의 수평 또는 수직 중심 근처로 레이어를 끌어오면 정렬 가이드가 동적으로 나타나며, Photoshop에서만 느낄 수 있을 것 같은 만족스러운 정확도로 워터마크를 정확히 중앙에 맞춰 줍니다.',
              ],
            },
            {
              title: '오른쪽 설정 패널',
              paragraphs: [
                '오른쪽 패널은 제어 센터입니다. 여기서 워터마크 레이어를 관리하고, 모양을 조정하며, 최종 내보내기를 실행합니다. 데스크톱에서는 화면 오른쪽에 고정되어 있습니다. 모바일에서는 떠 있는 톱니바퀴 버튼으로 호출되는 하단 시트 형태로 올라와 작업 중 캔버스를 가리지 않습니다.',
                '오른쪽 패널 안에는 레이어 관리자가 있으며, 추가한 모든 워터마크 요소가 나열됩니다. 각 레이어 항목에는 레이어 유형(텍스트 또는 이미지), 현재 이름이나 내용, 그리고 세 가지 빠른 작업 버튼이 표시됩니다. 표시/숨김 토글(눈 아이콘), 다른 레이어를 작업하는 동안 위치를 고정하는 잠금 토글, 삭제 버튼입니다.',
              ],
            },
            {
              title: '왼쪽 미리보기 스트립(다중 이미지 모드)',
              paragraphs: [
                '한 번에 여러 이미지를 작업할 때는, 예를 들어 제품 사진 묶음이나 전체 인물 촬영 세션을 처리할 때 화면의 가장 왼쪽에 세로 썸네일 스트립이 나타납니다. 이것이 이미지 큐이며, 불러온 각 파일의 축소 미리보기를 보여 줍니다. 썸네일을 클릭하면 캔버스가 즉시 해당 이미지로 바뀌어 레이어 설정을 잃지 않고도 다른 구도에서 워터마크가 어떻게 보이는지 확인할 수 있습니다.',
                '스트립에는 각 파일의 KB 또는 MB 크기와 파일 형식 태그(JPG, PNG, WEBP)도 표시되어 한눈에 무엇을 다루고 있는지 알 수 있습니다.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: '단계별',
          title: '단계별: Photremium에서 이미지에 워터마크를 추가하는 방법',
          paragraphs: [
            '이 안내는 드래그 앤 드롭 업로드 시스템부터 다운로드 전에 워터마크를 이미지에 영구적으로 써 넣는 캔버스 렌더링 엔진까지, 도구가 내부적으로 어떻게 작동하는지에 직접 기반합니다.',
          ],
          steps: [
            {
              heading: '1단계 — 이미지 업로드하기',
              paragraphsBefore: [
                'photremium.com/watermark-image로 이동합니다. 페이지 중앙에 깔끔한 드래그 앤 드롭 영역이 있는 업로드 화면이 나타납니다.',
                '이미지를 도구로 가져오는 방법은 세 가지입니다.',
              ],
              bullets: [
                '드래그 앤 드롭. 데스크톱에서 하나 이상의 이미지 파일을 드롭존으로 바로 끌어다 놓습니다. 도구는 JPEG, PNG, WEBP 등 모든 표준 이미지 형식을 지원합니다. 작업 공간 위로 파일을 끌면 전체 영역 주위에 보라색 테두리가 활성화되고 “Drop images to add for watermarking”이라는 시각적 안내가 표시되어 드롭이 인식되었음을 알 수 있습니다.',
                '클릭하여 찾아보기. 드롭존 안의 “Choose Files” 버튼을 클릭해 시스템 파일 선택기를 엽니다. Windows에서는 Ctrl+Click, Mac에서는 Cmd+Click으로 여러 파일을 한 번에 선택할 수 있습니다.',
                '클립보드에서 붙여넣기. 스크린샷, 다른 앱, 웹 브라우저 등에서 이미지를 클립보드에 복사해 두었다면 워터마크 페이지에서 Ctrl+V(Mac에서는 Cmd+V)를 누르기만 하면 이미지가 작업 공간에 직접 로드됩니다. 이미 여러 이미지가 로드되어 있어도 작동합니다.',
              ],
              paragraphsAfter: [
                '첫 번째 이미지가 로드되면 작업 공간은 업로드 화면에서 전체 3패널 편집기로 전환되고, canvas는 화면에 맞는 확대 수준으로 자동 계산된 상태로 이미지를 표시합니다.',
              ],
            },
            {
              heading: '2단계 — 텍스트 워터마크 레이어 추가하기',
              paragraphsBefore: [
                '오른쪽 패널의 보라색 “Add Text” 버튼을 클릭합니다. 기본 자리표시자 텍스트 “Type here...”가 선택된 상태로 새 텍스트 레이어가 canvas에 나타납니다.',
                '바로 입력을 시작할 수 있습니다. 텍스트는 이미지 크기에 맞춘 기본 크기로 흰색 Arial로 canvas에 실시간 렌더링됩니다. 텍스트 레이어가 선택되면 나타나는 상단 툴바에서 텍스트의 모든 측면을 사용자 정의할 수 있습니다.',
              ],
              bullets: [
                '폰트 패밀리 — Arial, Georgia, Impact, Brush Script MT, Comic Sans MS 등 12개의 내장 글꼴 중에서 선택',
                '폰트 크기 — 픽셀 값을 직접 입력하거나 증가/감소 컨트롤을 사용',
                '굵게, 기울임꼴, 밑줄 — 이 스타일 조합을 원하는 대로 활성화',
                '텍스트 색상 — 색상 견본을 클릭해 색상 선택기를 열고 원하는 hex 색상 선택',
                '배경색 — 텍스트 뒤에 색상 배경을 넣어 라벨이나 배지 같은 느낌을 연출',
                '스트로크(윤곽선) — 밝은 이미지와 어두운 이미지 모두에서 최대 가독성을 위해 스트로크 너비와 색상 설정',
                '불투명도 — 0%(보이지 않음)부터 100%(완전 불투명)까지 조절; 대부분의 워터마크는 30%에서 60% 사이에 위치',
                '정렬 — 텍스트를 바운딩 박스 안에서 왼쪽, 가운데, 오른쪽 정렬',
                '회전 — 텍스트 레이어를 원하는 각도로 회전하고, 0°, 90°, 180°, 270°에서 자석 스냅 포인트로 빠르게 직각 배치',
              ],
              paragraphsAfter: [
                '텍스트를 이동하려면 canvas에서 클릭하고 드래그하세요. 픽셀 단위의 세밀한 위치 조정은 키보드의 화살표 키를 사용하면 됩니다(Shift를 누르면 10픽셀 단위). 텍스트 상자 크기를 바꾸려면 선택한 레이어 주위에 나타나는 8개의 크기 조절 핸들(모서리와 가장자리)을 드래그합니다.',
              ],
            },
            {
              heading: '3단계 — 이미지(로고) 워터마크 레이어 추가하기',
              paragraphsBefore: [
                '로고, 서명 또는 어떤 이미지든 텍스트 대신 또는 텍스트와 함께 워터마크로 사용하려면 오른쪽 패널의 파란색 “Add Image” 버튼을 클릭합니다. 파일 선택기가 열리므로 기기에서 워터마크 이미지 파일을 선택할 수 있습니다.',
                '도구는 워터마크 이미지를 원래 비율을 유지한 채 canvas 너비의 약 30%로 자동 조정하고, canvas 중앙에 배치합니다. 그다음 원하는 위치로 드래그할 수 있고, 모서리 핸들로 크기를 조절할 수 있으며(비율 유지), 선택한 레이어 위에 나타나는 전용 회전 핸들로 회전할 수도 있습니다.',
                '이미지형 워터마크 레이어의 경우 오른쪽 패널에 추가 제어가 표시됩니다.',
              ],
              bullets: [
                '불투명도 — 텍스트 레이어와 동일하며 투명 PNG 로고에 이상적',
                '가로 뒤집기 / 세로 뒤집기 — 필요하면 워터마크를 반전',
                '테두리 너비, 테두리 색상, 테두리 스타일 — 로고 워터마크 주위에 보이는 테두리 추가',
                '테두리 반경 — 로고의 모서리를 균일하게 또는 각 모서리별로 따로 둥글게 처리',
                '회전 — 텍스트 레이어와 동일한 부드러운 회전 동작',
              ],
            },
            {
              heading: '4단계 — 타일링 설정하기(선택 사항)',
              paragraphsBefore: [
                '도구의 강력한 기능 중 하나는 타일링입니다. 워터마크를 이미지 전체에 그리드 패턴으로 반복 배치할 수 있습니다. 단순히 브랜드를 넣는 것보다 이미지가 재게시용으로 쓸모없게 만들고 싶을 때 특히 유용합니다.',
                '레이어가 선택된 상태에서 툴바의 tile 옵션을 찾으세요. 다음처럼 설정할 수 있습니다.',
              ],
              bullets: [
                '없음 — 단일 배치(기본값)',
                '2×2 그리드 — 2열 2행 패턴으로 워터마크 반복',
                '3×3 그리드 — 더 촘촘한 커버리지를 위해 3×3 그리드로 반복',
              ],
              paragraphsAfter: [
                '타일 간 간격도 조정할 수 있으며, 이는 반복본 사이의 간격을 제어합니다. canvas는 타일 복사본의 고스트 미리보기를 보여 주므로 다운로드 전에 전체 커버리지 패턴을 확인할 수 있습니다.',
              ],
            },
            {
              heading: '5단계 — 레이어 관리자를 사용해 여러 워터마크 다루기',
              paragraphsBefore: [
                '원하는 만큼 레이어를 추가할 수 있으며, 텍스트와 이미지 워터마크를 자유롭게 섞을 수 있습니다. 오른쪽 패널의 레이어 관리자가 이를 모두 나열합니다. 할 수 있는 일은 다음과 같습니다.',
              ],
              bullets: [
                '눈 아이콘으로 개별 레이어를 표시/숨김 — 삭제하지 않고 다른 워터마크 버전 사이를 전환하는 데 유용',
                '다른 레이어를 작업하는 동안 실수로 움직이지 않도록 레이어 잠그기',
                '레이어 영구 삭제',
              ],
              paragraphsAfter: [
                '목록의 어떤 레이어 항목을 클릭해도 동시에 canvas에서 선택되므로, 이미지에서 일일이 찾지 않고도 레이어 사이를 쉽게 전환할 수 있습니다.',
              ],
            },
            {
              heading: '6단계 — 여러 이미지 사이 전환하기',
              paragraphsBefore: [
                '한 번에 한 장 이상 업로드했다면 왼쪽의 썸네일 스트립을 사용해 활성 canvas 이미지를 전환하세요. 설정한 워터마크 레이어는 공통적으로 적용되며, 내보낼 때 배치의 모든 이미지에 렌더링됩니다.',
                '도구는 배치 전체에 대해 해상도 일관성 검사도 수행합니다. 이미지 크기가 크게 다르면(너비 또는 높이 차이가 5% 이상이면) 워터마크 위치가 이미지마다 다르게 보일 수 있다는 경고가 표시됩니다. 엔진은 비율 기반 재배치 알고리즘으로 이를 부드럽게 처리합니다. 기준 이미지의 크기에 대한 백분율로 워터마크 위치를 계산하고, 같은 비례 배치를 나머지 모든 이미지에 적용하여 해상도가 달라도 시각적 의도를 유지합니다.',
              ],
            },
            {
              heading: '7단계 — 다운로드 기본 설정 지정하기',
              paragraphsBefore: [
                '단일 이미지 작업에서는 canvas 아래의 “Download” 버튼을 클릭해 워터마크가 적용된 이미지를 바로 저장합니다. 파일 이름은 자동으로 원래 이름에 “-watermarked”가 확장자 앞에 붙은 형태로 설정됩니다. JPEG 이미지는 품질 0.95로 내보내며, 일반적인 보기 크기에서는 원본과 구분하기 어려울 정도로 충분히 높습니다. PNG 이미지는 무손실 PNG로 내보내집니다.',
                '여러 이미지를 한꺼번에 처리하는 경우, 오른쪽 패널에서 두 가지 다운로드 모드를 선택할 수 있습니다.',
              ],
              bullets: [
                'ZIP 파일 — 모든 워터마크 이미지를 하나의 ZIP 아카이브로 묶어 한 번에 다운로드합니다. 압축을 위해 JSZip을 동적으로 로드합니다.',
                '개별 파일 — 각 이미지를 개별 파일로 다운로드하며, 브라우저 제한을 피하기 위해 다운로드 사이에 짧은 지연이 있습니다.',
              ],
            },
            {
              heading: '8단계 — 다운로드하고 확인하기',
              paragraphsBefore: [
                '다운로드 버튼(배치의 경우 “Watermark & Download All” 버튼)을 클릭하면, 도구는 각 이미지를 화면에 보이는 축소 미리보기 크기가 아닌 숨겨진 HTML5 canvas 요소에서 원본 네이티브 해상도로 렌더링합니다. 즉, 내보낸 이미지는 원본 픽셀 크기의 100%이며 워터마크는 비례적으로 올바른 크기로 그려집니다. 다운로드한 파일을 열어 확대해서 워터마크 위치와 품질이 기대에 맞는지 확인하세요.',
                '무언가 이상해 보인다면 작업 공간으로 돌아가면 됩니다. 레이어는 그대로 남아 있으니 조정한 뒤 다시 다운로드하세요.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: '전문가 팁',
          title: '최상의 결과를 위한 전문가 팁',
          bullets: [
            '가장 전문적으로 보이게 하려면 반투명 PNG 로고를 사용하세요. 투명 배경에 40~50% 불투명도의 로고 워터마크는 단색 텍스트보다 훨씬 세련돼 보입니다. 이미지 레이어로 사용하기 전에 디자인 도구에서 알파 투명성이 포함된 PNG로 로고를 내보내세요.',
            '잘려 나가면 가치가 사라지는 위치에 워터마크를 두세요. 오른쪽 아래 모서리는 가장 흔한 위치이자 잘라 내기 가장 쉬운 곳입니다. 더 강한 보호를 원한다면 얼굴, 제품 디테일, 초점 지점처럼 시각적으로 중요한 영역 위에 워터마크를 배치하는 것을 고려하세요. 대각선 타일은 이미지를 크게 손상시키지 않고 제거하기가 훨씬 어렵습니다.',
            '여러 레이어를 다룰 때는 잠금 기능을 활용하세요. 기본 워터마크 위치가 만족스러우면 보조 레이어를 추가하기 전에 그 레이어를 잠그세요. 그러면 다른 요소를 작업하는 동안 실수로 위치를 건드리는 일을 막을 수 있습니다.',
            '이미지의 밝은 영역과 어두운 영역 모두에서 테스트하세요. 흰색 워터마크는 밝은 하늘에서는 보이지 않지만 어두운 그림자에서는 또렷하게 읽힙니다. 워터마크 아래의 내용과 상관없이 가독성을 유지하려면 은은한 스트로크나 배경색을 추가하세요.',
            '키보드 단축키는 언제나 시간을 절약합니다. 화살표 키는 선택한 레이어를 한 번에 1픽셀씩 이동합니다. Shift+화살표는 10픽셀씩 이동합니다. Delete 키는 선택한 레이어를 즉시 삭제합니다. 이런 단축키는 드래그보다 훨씬 빠르게 위치를 세밀하게 조정하게 해 줍니다.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: '개인정보와 보안',
          title: '개인정보와 보안: 브라우저 기반 처리가 중요한 이유',
          paragraphs: [
            '온라인 도구를 사용할 때 많은 창작자가 가장 걱정하는 것은 이미지가 실제로 어디로 가는가 하는 점입니다. 서버 기반 워터마크 도구에서는 이미지가 공급자 서버로 업로드되어 그곳에서 처리된 뒤 다시 돌아옵니다. 즉, 아직 공개되지 않은 작업물, 고객 사진, 민감한 제품 이미지가 다른 사람의 인프라를 거치게 됩니다.',
            'Photremium의 워터마크 도구는 모든 것을 브라우저 안에서 로컬 처리합니다. 이미지는 브라우저의 File API를 사용해 기기 메모리에 로드되며 인터넷으로 전송되지 않습니다. 워터마크 렌더링은 JavaScript로 실행되는 HTML5 canvas 요소에서 브라우저 탭 내부에서만 이루어집니다. 페이지를 닫거나 “Start Over”를 클릭하면 모든 이미지 데이터가 메모리에서 해제되고 폐기됩니다. 자기 기기 외에는 어디에도 저장되지 않습니다.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: '최종 요약',
          title: 'Photremium 워터마크 도구가 정기적인 작업 흐름에 들어갈 이유',
          paragraphs: [
            '온라인에는 수십 개의 워터마크 도구가 있습니다. 북마크할 가치가 있는 도구와 잊어도 되는 도구를 가르는 것은 보통 속도, 제어, 신뢰성의 조합입니다.',
            '속도가 중요한 이유는 워터마크 작업이 후처리 워크플로에 큰 시간을 더해서는 안 되기 때문입니다. Photremium 도구는 즉시 로드되고, 로컬에서 처리되며, 대용량 배치도 몇 초 만에 전체 해상도로 내보냅니다. 서버 측 처리 대기, 큐, 동시에 온라인인 사용자 수에 따라 길어지는 렌더링 시간이 없습니다.',
            '제어가 중요한 이유는 보기 이상한 워터마크가 없는 것보다 더 나쁘기 때문입니다. 브랜드를 비전문적으로 보이게 합니다. 레이어 시스템, 툴바의 속성별 제어, 실시간 canvas 미리보기, 키보드 단축키 지원이 합쳐져 전용 데스크톱 소프트웨어에 견줄 만한 수준의 제어를 제공합니다.',
            '신뢰성이 중요한 이유는 아직 공개되지 않은 작업이 가치 있기 때문입니다. 이미지가 인터넷을 통해 제3자 서버로 가지 않는다는 사실을 알면, 고객 사진, 출시 전 제품 이미지, 민감한 창작물을 데이터 처리나 서버 측 침해, 클라우드 공급자의 정책 변경을 걱정하지 않고 워터마크할 수 있습니다.',
            '한 장의 사진에 빠른 저작권 고지를 넣든, 고객 갤러리를 공유하기 전에 200장 전체를 처리하든, Photremium의 Watermark Image 도구는 그것을 제대로 할 수 있는 도구를 제공합니다. 완전히 무료이고, 완전히 비공개이며, 워터마크가 이미지 위에 덧붙인 것이 아니라 그 이미지에 속한 것처럼 보이게 할 만큼 충분한 창작 유연성을 갖추고 있습니다.',
            'photremium.com/watermark-image에 들어가 직접 사용해 보세요. 첫 번째 워터마크 이미지는 정말로 30초 남았습니다.',
            'Photremium은 브라우저 기반 이미지 편집 및 처리 도구 모음을 제공합니다. 모든 도구는 브라우저에서 로컬로 실행되며, 이미지는 기기에 그대로 남습니다.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'QR 코드 생성기 — 무료 생성 및 사용자 정의 | photremium.com',
      inputDesc: 'URL, 텍스트, WiFi, 연락처, 이메일, Google Maps를 위한 맞춤형 QR 코드 생성.',
      inputKeywords: 'qr 코드 생성기, qr 코드 만들기, 맞춤형 qr 코드',
      customizeTitle: 'QR 코드 사용자 정의 — photremium.com',
      customizeDesc: 'QR 코드의 스타일, 색상, 프레임, 로고를 사용자 정의. PNG, JPG, SVG, WEBP 또는 PDF로 다운로드.',
      customizeKeywords: 'qr 코드 사용자 정의, qr 코드 스타일',
    },
    title: 'QR 코드 생성기',
    desc: 'URL, 텍스트, WiFi, 연락처, 이메일, 지도용 QR 코드를 생성, 사용자 정의, 다운로드합니다.',
    generate: '생성',
    scanQrCode: 'QR 코드 스캔',
    tabUrl: '링크 / URL',
    tabText: '텍스트',
    tabWifi: 'WiFi',
    tabContact: '연락처',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'URL 입력',
    enterText: '텍스트 입력',
    networkName: '네트워크 이름 (SSID)',
    password: '비밀번호',
    encryption: '암호화',
    hiddenNetwork: '숨겨진 네트워크',
    contactName: '연락처 이름 (선택)',
    phoneNumber: '전화번호',
    emailAddress: '이메일 주소',
    subject: '제목 (선택)',
    body: '본문 (선택)',
    searchLocation: '위치 검색',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: '텍스트를 여기에 입력하세요…',
    wifiNamePlaceholder: '내 WiFi',
    passwordPlaceholder: '비밀번호',
    contactPlaceholder: '홍길동',
    phonePlaceholder: '+82 10 1234 5678',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: '제목',
    bodyPlaceholder: '이메일 본문…',
    locationPlaceholder: '도시, 주소, 장소 검색…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: '없음',
    characters: '자',
    generateCustomize: '생성 및 사용자 정의',
    editQrData: 'QR 데이터 편집',
    styleShape: '스타일 및 모양',
    colorTab: '색상',
    framesTab: '프레임',
    logoTab: '로고',
    templatesTab: '템플릿',
    fileFormatTab: '파일 형식',
    fgColor: '전경 색상',
    bgColor: '배경 색상',
    enableGradient: '그라데이션 활성화',
    gradientType: '그라데이션 유형',
    linear: '선형',
    radial: '방사형',
    selectFrame: '프레임 선택',
    selectLogo: '로고 선택',
    uploadCustomLogo: '또는 사용자 정의 로고 업로드',
    uploadImage: '이미지 업로드',
    downloadFormat: '다운로드 형식',
    preview: '미리보기',
    downloadFormatBtn: '{format} 다운로드',
    pngDesc: '무손실, 투명도 지원',
    jpgDesc: '대중적이고 범용적인 파일 형식',
    webpDesc: '최신 형식, 최적의 품질/용량',
    svgDesc: '확장 가능한 벡터 그래픽',
    pdfDesc: '인쇄용 문서',
    lat: '위도:',
    lng: '경도:',
    qrCode: 'QR 코드',
    scanMe: '스캔하세요',
    scanHere: '여기서 스캔',
    blog: {
      card1: {
        title: '1. QR 코드는 무엇인가요?',
        intro1: 'QR 코드의 정식 명칭은 “Quick Response code”입니다. 저장된 정보를 매우 빠르게 해독할 수 있기 때문에 Quick Response(QR) 코드라고 부릅니다.',
        intro2: 'QR 코드는 기계가 읽는 2차원 디지털 코드입니다. 사람이 내부 데이터를 직접 읽을 수는 없습니다. 텍스트, 연락처 번호, 링크, Google 지도 위치 등 다양한 정보를 모듈에 저장할 수 있습니다.',
        inventionTitle: 'QR 코드는 어떻게 발명되었나요:',
        inventionText: 'QR 코드는 1994년에 발명되었습니다. Masahiro Hara와 그의 팀은 Toyota용 자동차 부품을 만들던 일본 회사 Denso Wave에서 일하고 있었습니다. 기존 바코드보다 훨씬 많은 정보를 저장할 수 있는 코드를 원했고, 그 결과 QR 코드가 탄생했습니다.',
        keyFeaturesTitle: 'QR 코드의 핵심 특징',
        keyFeatures: [
          {
            title: 'QR 작동 방식',
            text: '텍스트나 링크를 입력하면 해당 정보로 QR 코드가 생성됩니다. QR 생성기는 정보에 따라 사각형 모듈을 만듭니다. 각 모듈은 비트를 나타내며, 비트들이 문자를 구성해 저장합니다.',
          },
          {
            title: 'QR 코드 구조',
            text: 'QR 코드에는 방향을 인식하기 위한 큰 사각형 3개와, 비트(정보)를 저장하는 작은 사각형 모듈들이 포함됩니다.',
          },
          {
            title: 'QR 코드 데이터 용량',
            text: '일반적으로 QR 코드는 바코드보다 더 많은 정보를 저장합니다. QR 코드는 바코드의 고급 버전으로, 기본적으로 2차원 바코드입니다. 보통 약 200자를 저장할 수 있습니다. 400자까지도 가능하지만 스캔이 어려워질 수 있습니다. 400자를 넘기면 코드가 매우 복잡해져 대부분 스캔이 잘 되지 않을 수 있습니다.',
          },
          {
            title: 'QR 코드 오류 감지',
            text: 'QR 코드 일부가 긁히거나 일부 비트가 손상되어도 스캔 가능한 경우가 많습니다. QR 코드는 Reed-Solomon 오류 검출/정정 기법을 사용해 오류를 찾아 복구합니다.',
          },
        ],
        errorTitle: 'QR 코드 오류 정정 레벨:',
        errorIntro: '아래와 같이 사용 환경에 따라 서로 다른 오류 검출 및 정정 기법이 적용됩니다:',
        errorHeaders: {
          level: '레벨',
          recovery: '복구 용량',
          bestUse: '최적 사용 사례',
        },
        errorRows: [
          {
            level: '낮음 (L)',
            recovery: '~7%',
            useCases: [
              'QR 코드를 디지털 화면, 웹사이트 또는 깨끗한 환경에 표시할 때 사용합니다.',
              'Gmail, 연락처 번호, 짧은 텍스트처럼 정보량이 적을 때 적합합니다.',
            ],
          },
          {
            level: '중간 (M)',
            recovery: '~15%',
            useCases: [
              '깨끗한 환경에 부착된 전단지/포스터처럼 손상 위험이 낮은 경우에 적합합니다.',
            ],
          },
          {
            level: '사분위 (Q)',
            recovery: '~25%',
            useCases: [
              '공장/야외처럼 거친 환경에 QR 코드를 설치할 때 사용합니다.',
              '중앙에 작은 로고를 넣어 일부 비트를 가리게 되는 경우에도 이 레벨이 필요합니다.',
            ],
          },
          {
            level: '높음 (H)',
            recovery: '~30%',
            useCases: [
              'QR 코드가 크게 손상될 가능성이 있는 경우 사용합니다.',
              '큰 로고가 QR 코드 중앙을 가릴 때 사용합니다.',
              '강한 스타일링이 필요한 디자인에서도 적합합니다.',
            ],
          },
        ],
      },
      card2: {
        title: '2. 왜 우리 QR 코드 생성기를 선택해야 하나요?',
        intro: '우리 QR 코드 생성기는 QR 코드 생성을 매우 빠르고 안전하며 쉽게 만들어 줍니다. 비즈니스 테마에 맞게 더 고급스럽고 전문적으로 커스터마이즈할 수 있습니다. QR 코드 색상 변경부터 로고 삽입까지 모든 커스터마이즈 기능을 영구적으로 무료 제공합니다.',
        strengths: [
          {
            title: '전문가 수준 커스터마이즈:',
            text: '필요한 만큼 QR 코드를 무료로 생성하고 커스터마이즈할 수 있습니다. 모든 기능이 완전 무료이며, 그라데이션 색상, 다양한 모듈 형태, 사용자 로고 등 많은 옵션을 제공합니다.',
          },
          {
            title: '다중 포맷 지원:',
            text: '편의를 위해 다양한 다운로드 포맷을 제공합니다. 다운로드 전에 원하는 포맷만 선택하면 됩니다. 현재 제공 포맷은 다음과 같습니다:',
          },
          {
            title: '사전 제작 템플릿:',
            text: '미리 준비된 그라데이션 색상과 프레임을 사용해 QR 코드를 더 전문적으로 만들 수 있습니다.',
          },
          {
            title: '사용자 로고 지원:',
            text: '브랜드 로고를 업로드하면 QR 코드 중앙에 자동으로 맞춰 배치됩니다. 또한 30개 이상의 로고가 있는 내장 로고 라이브러리에서 선택할 수도 있습니다.',
          },
          {
            title: '실시간 미리보기:',
            text: '커스터마이즈 중 모든 변경 사항을 실시간 미리보기 패널에서 확인할 수 있으며, 변경 내용이 동적으로 즉시 반영됩니다.',
          },
          {
            title: '스캔 가능성 안내:',
            text: '색상을 고를 때 스캔이 어려운 조합을 선택하면 적절한 경고와 안내 표시로 알려줍니다.',
          },
        ],
        formatHeaders: {
          srNo: '번호',
          formats: '포맷',
          description: '설명',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: '무손실, 투명 배경 지원' },
          { no: '2', format: 'JPG', description: '대중적이고 범용적인 파일 포맷' },
          { no: '3', format: 'WEBP', description: '최신 포맷, 뛰어난 품질/용량 비율' },
          { no: '4', format: 'SVG', description: '확대 축소 가능한 벡터 그래픽' },
          { no: '5', format: 'PDF', description: '인쇄용 문서 포맷' },
        ],
      },
      card3: {
        title: '3. 단계별 가이드:',
        step1Intro: '먼저 생성하려는 QR 코드의 카테고리를 선택하세요. 연락처, 지도, 링크, 텍스트 등 원하는 목적에 맞게 선택할 수 있습니다. 현재 우리 QR 코드 생성기는 다음 카테고리를 제공합니다:',
        categories: ['링크 / URL', '텍스트', 'WiFi', '연락처', 'Gmail', 'Google Maps'],
        step2: '카테고리를 선택한 뒤 해당 입력 상자에 정보를 붙여넣으세요.',
        step3Intro: '그다음 Generate & Customize를 클릭해 커스터마이즈 패널을 엽니다. 패널에는 다음과 같은 하위 옵션이 있습니다:',
        options: [
          {
            title: '스타일 및 모양:',
            text: '이 섹션에서는 모듈 모양을 둥근 모서리, 점, 가로 막대, 세로 막대, 작은 사각형 등 다양한 스타일로 변경할 수 있습니다.',
          },
          {
            title: '색상:',
            text: '이 섹션에서 배경색과 전경색을 사용자 지정할 수 있습니다. QR 코드를 그라데이션으로 만들려면 그라데이션 옵션을 활성화하면 되며, 내장 라이브러리의 그라데이션을 적용하거나 직접 만들 수 있습니다. 선형 그라데이션의 각도도 조절할 수 있고, 방사형 그라데이션도 지원합니다. 여러 색상을 추가해 더 전문적인 그라데이션 효과를 만들 수 있습니다.',
          },
          {
            title: '프레임:',
            text: '여기에서 QR 코드에 맞는 프레임을 선택할 수 있습니다. 모든 프레임은 코드에 자동으로 맞춰집니다. 내장 라이브러리에서 원하는 프레임을 고르기만 하면 됩니다.',
          },
          {
            title: '로고:',
            text: '프레임 선택 후 QR 코드 중앙에 자동 배치되는 로고를 선택할 수 있습니다. 사용자 브랜드 로고 업로드도 지원됩니다.',
          },
          {
            title: '템플릿:',
            text: '스타일, 모양, 색상, 프레임을 각각 선택하고 싶지 않다면 사전 제작 템플릿을 적용할 수 있습니다. 편의를 위해 여러 프리미엄 템플릿을 제공하며 영구 무료입니다.',
          },
          {
            title: '파일 형식:',
            text: '마지막으로 QR 코드를 다운로드할 파일 형식을 선택하면 됩니다. PNG, WEBP, SVG, PDF 등 여러 일반 포맷을 지원합니다.',
          },
          {
            title: 'QR 데이터 편집:',
            text: '선택한 커스터마이즈를 유지한 채 QR 데이터만 별도로 수정할 수도 있습니다.',
          },
        ],
        finalStep: '이제 다운로드 버튼을 클릭하면, 선택한 커스터마이즈와 파일 형식이 그대로 적용된 QR 코드가 즉시 무료로 다운로드됩니다.',
      },
      card4: {
        title: '4. 장점:',
        intro: 'QR 코드는 물리적 세계와 디지털 경험을 연결합니다. 링크, 연락처, 위치를 공유하는 가장 빠른 방법입니다. QR 코드를 스캔하기만 하면 정보를 즉시 확인할 수 있습니다. 시간 효율이 높고 목적성이 뛰어나 비즈니스와 디지털 환경에서 매우 널리 사용됩니다.',
        benefits: [
          {
            title: '장기 사용 가능:',
            text: 'QR 코드는 별도의 만료 없이 오래 사용할 수 있습니다. 스캔하면 저장된 정보를 즉시 제공합니다. 하드코딩된 디지털 지시를 저장하므로 정보가 자연스럽게 사라지지 않습니다.',
          },
          {
            title: '오프라인 지원:',
            text: '오프라인 상태에서도 QR 코드를 스캔할 수 있습니다. 모바일 카메라가 QR 패턴을 해독해 내부에 저장된 정보를 보여줍니다.',
          },
          {
            title: '비용 없음:',
            text: '이러한 코드는 서버 리디렉션이나 추가 리소스를 요구하지 않기 때문에 영구적으로 무료로 사용할 수 있습니다.',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'QR 코드 스캐너 — 카메라 또는 이미지에서 QR 코드 스캔 | photremium.com',
      desc: '카메라나 이미지 업로드로 QR 코드를 즉시 스캔. URL, 텍스트, WiFi, 연락처 등 감지.',
      keywords: 'qr 코드 스캐너, qr 코드 스캔, qr 리더, qr 코드 온라인',
    },
    title: 'QR 코드 스캐너',
    desc: '카메라나 이미지 업로드로 QR 코드를 즉시 스캔. 빠르고 안전합니다.',
    generateQrCode: 'QR 코드 생성',
    scan: '스캔',
    cameraScanner: '카메라 스캐너',
    uploadImage: '이미지 업로드',
    pointCamera: '카메라를 QR 코드에 향하세요',
    startCamera: '카메라 시작',
    loading: '로딩 중…',
    dropQrImage: 'QR 코드 이미지를 여기에 놓으세요',
    toScan: '스캔할',
    supportedFormats: 'JPG, PNG, GIF, WEBP 지원',
    ctrlVPaste: 'Ctrl+V로 붙여넣기',
    scanFromGallery: '갤러리에서 스캔',
    accessingCamera: '카메라 접근 중…',
    cameraDenied: '카메라 접근이 거부되었습니다. 카메라 권한을 허용하고 다시 시도하세요.',
    noCamera: '이 기기에서 카메라를 찾을 수 없습니다.',
    cameraError: '카메라에 접근할 수 없습니다. 다시 시도하세요.',
    tryAgain: '다시 시도',
    switchCamera: '카메라 전환',
    stop: '정지',
    noQrFound: 'QR 코드를 찾을 수 없음',
    couldNotRead: '이미지를 읽을 수 없음',
    scannerFailed: '스캐너 로드 실패',
    noQrFoundDesc: '이미지에서 QR 코드가 감지되지 않았습니다. 다른 이미지를 시도하거나 카메라 스캐너를 사용하세요.',
    qrScanned: 'QR 코드 스캔됨!',
    openLink: '링크 열기',
    copied: '복사됨!',
    copy: '복사',
    share: '공유',
    scanAgain: '다시 스캔',
    network: '네트워크',
    password: '비밀번호',
    security: '보안',
    unknown: '알 수 없음',
    blog: {
      tocTitle: '목차',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. 왜 QR 코드 스캐너를 사용하나요?',
          paragraphs: [
            'QR 코드 스캐너는 기본적으로 QR 코드에 저장된 정보를 디코딩하는 모바일 카메라입니다. 카메라를 QR 코드에 맞추기만 하면, 방향과 관계없이 특정 패턴을 읽고 오류를 감지하며 필요 시 수정한 뒤 정보를 표시합니다.',
          ],
          listTitle: 'QR 코드 스캐너의 종류:',
          bullets: [
            '웹 기반 QR 코드 스캐너: 브라우저가 지원하는 온라인 스캐너로 QR 코드를 읽을 수 있습니다. 카메라로 스캔하거나 이미지를 업로드해 정보를 확인할 수 있습니다. 자동 리디렉션 등 고급 기능은 https://photremium.com 에서 이용할 수 있습니다.',
            '모바일 카메라: 일부 최신 스마트폰은 기본 카메라 앱에 QR 스캐너가 내장되어 있습니다. 카메라를 QR 코드에 비추는 것만으로 정보를 인식하고 디코딩할 수 있습니다.',
            '앱: QR 코드 스캔 전용 앱도 있습니다. 하지만 고급 리디렉션과 다양한 기능을 사용하려면 이 링크에서 무료로 앱을 이용할 수 있습니다: https://photremium.com.',
            '하드웨어 장치: QR 코드를 스캔하는 전용 하드웨어 장치도 있습니다. 대형 쇼핑몰에서 계산/결제 처리에 널리 사용됩니다.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. 왜 우리 QR 코드 스캐너를 선택해야 하나요?',
          paragraphs: [
            'QR 코드에서 디코딩한 내용을 복사하는 기능부터 리디렉션까지 다양한 고급 기능을 사용할 수 있습니다. 우리 QR 코드 스캐너에는 다음과 같은 유용한 기능도 있습니다:',
          ],
          bullets: [
            '빠른 속도: 우리 QR 코드 스캐너는 디코딩 속도가 매우 빠릅니다. QR 코드를 스캔하기만 하면 텍스트/링크 복사, 링크 감지 시 열기, 연락처 감지 시 자동 저장 등의 고급 옵션과 함께 즉시 정보를 제공합니다.',
            '설치 불필요: QR 코드 스캐너를 쓰기 위해 별도 앱 설치가 필요하지 않습니다. 브라우저에서 무료로 바로 사용할 수 있습니다.',
            '크로스 플랫폼 접근: 어떤 기기에서도 사용할 수 있습니다. OS 버전이나 추가 요구사항을 걱정할 필요가 없습니다.',
            '모든 형식 지원: 일반 텍스트, WiFi, URL, 연락처, Gmail, Google Maps 등 QR 코드에 담을 수 있는 주요 데이터 형식을 폭넓게 지원합니다.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. 단계별 가이드:',
          steps: [
            {
              heading: '1. 먼저 QR 코드를 스캔할 방법을 선택하세요. 다음 두 가지 방법이 있습니다:',
              subSteps: [
                {
                  heading: 'i. 카메라 방식',
                  paragraphs: [
                    '노트북, PC 또는 일반 카메라를 지원하는 모든 기기에서 디바이스 카메라로 QR 코드를 스캔할 수 있습니다. “카메라 시작” 버튼을 누르면 권한 요청이 표시되며, QR 스캔을 위해 카메라 사용을 허용하면 됩니다. 실수로 거부했거나 요청이 보이지 않는 경우 아래 단계로 수동 허용할 수 있습니다:',
                  ],
                  notes: [
                    '➔ Chrome (Android / Desktop)에서:',
                    '1. 오른쪽 상단 점 3개를 클릭',
                    '2. 설정으로 이동',
                    '3. (Android는 생략) 개인정보 및 보안',
                    '4. 사이트 설정 클릭',
                    '5. 권한 섹션에서 카메라 클릭',
                    '6. 사이트 URL https://photremium.com/qr-code-scanner 찾기',
                    '7. 드롭다운에서 카메라를 허용으로 설정.',
                    '➔ Safari (iPhone / iOS)에서:',
                    '1. 주소 표시줄의 AA 또는 Website Settings 아이콘을 탭.',
                    '2. Website Settings 선택.',
                    '3. Camera를 탭하고 Allow 선택.',
                    '4. 여전히 차단되면: iPhone 설정 > Safari > Camera에서 Ask 또는 Allow로 설정.',
                  ],
                },
                {
                  heading: 'ii. 갤러리 방식',
                  paragraphs: [
                    'QR 코드 이미지를 업로드해 정보를 확인할 수 있습니다. “갤러리에서 스캔” 버튼을 누르면 파일 탐색기가 열립니다. 이후 QR 코드 이미지를 선택하세요. .jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz, .xbm 등 다양한 형식을 지원합니다.',
                  ],
                },
              ],
            },
            {
              heading: '2. QR 코드를 선택하면 모든 정보가 표시되어 복사/공유/링크 열기(감지 시)가 가능합니다. 원하면 다시 스캔할 수도 있습니다.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'QR 코드 스캐너의 장점:.',
          paragraphs: [
            'QR 코드 스캐너는 디지털 환경에서 다양한 이점을 제공합니다. 결제, 인증, 정보 접근을 더 쉽고 빠르게 만들며 오프라인에서도 유용합니다.',
          ],
          bullets: [
            '정보 즉시 접근: QR 코드를 스캔하면 밀리초 단위로 정보를 받을 수 있습니다. 패턴 디코딩, 오류 감지/보정을 빠르게 수행해 매우 빠른 사용자 경험을 제공합니다.',
            '원활한 커뮤니케이션: 은행 정보나 상품 정보 같은 작은 데이터도 빠르고 안전한 전달이 중요합니다. QR 스캐너는 이를 돕습니다. 결제는 QR 스캔으로 처리되고, Google도 노트북에서 계정 생성 시 QR로 휴대폰 인증을 사용하는 경우가 있습니다.',
            '전자 티켓: 버스/기차역, 공항에서 오래 기다리지 않고 티켓을 확인할 수 있습니다. 공항의 다중 QR 스캐너 배치는 대기열을 줄이고 인력 부담을 낮춰 비용 절감에도 기여합니다.',
            '상품 진위 확인: 고급 브랜드는 제품에 QR 코드를 부착합니다. 고객은 이를 스캔해 정품 여부를 확인할 수 있습니다.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: '얼굴 블러 도구 — 온라인에서 이미지의 얼굴 블러 처리 | photremium.com',
      uploadDesc: 'AI 얼굴 감지로 이미지의 얼굴을 자동으로 블러 처리. 블러 강도, 모양 또는 이모지 선택.',
      uploadKeywords: '얼굴 블러, 얼굴 블러 처리, 얼굴 감지, 개인정보 도구',
      workspaceTitle: '얼굴 블러 도구 — photremium.com',
      workspaceDesc: '이미지의 얼굴을 자동으로 블러 처리. 100% 무료.',
      workspaceKeywords: '얼굴 블러, 얼굴 감지',
    },
    title: '얼굴 블러',
    desc: '개인정보 보호를 위해 이미지의 얼굴을 자동으로 감지하고 블러 처리합니다.',
    toBlurFaces: '얼굴을 블러 처리할',
    autoDetection: '자동 감지',
    autoDetectionDesc: 'AI 얼굴 감지가 모든 얼굴을 즉시 찾습니다',
    customBlur: '맞춤 블러',
    customBlurDesc: '블러 강도, 모양, 스타일 조정',
    private100: '100% 비공개',
    private100Desc: '모든 처리가 브라우저에서 로컬로 이루어집니다',
    blurTools: '블러 도구',
    faces: '얼굴',
    faceDetection: '얼굴 감지',
    detecting: '감지 중...',
    autoDetectFaces: '얼굴 자동 감지',
    exitManualMode: '수동 모드 종료',
    manualSelect: '수동 선택',
    nFaceRegions: '{n}개 얼굴 영역 발견',
    noFacesDetected: '얼굴이 감지되지 않음 — 수동 모드 사용',
    manualHint: '이미지에서 블러 처리할 영역 위에 사각형을 그리려면 클릭하고 드래그하세요.',
    blurType: '블러 유형',
    blur: '블러',
    emoji: '이모지',
    blurIntensity: '블러 강도',
    strength: '강도',
    blurShape: '블러 모양',
    rectangle: '직사각형',
    ellipse: '타원',
    circle: '원형',
    chooseEmoji: '이모지 선택',
    blurRegionsN: '블러 영역 ({n})',
    faceN: '얼굴 {n}',
    manualRegionN: '수동 영역 {n}',
    manualN: '수동 {n}',
    clearAllRegions: '모든 영역 지우기',
    processingDots: '처리 중...',
    downloadBlurred: '블러 이미지 다운로드',
    downloadNImages: '{n}개 이미지 다운로드',
    downloadDialogTitle: '모든 이미지가 편집되지 않음',
    downloadDialogText: '{total}개 중 {edited}개를 편집했습니다.',
    downloadAll: '모두 다운로드',
    removeRegion: '영역 제거',
    region: '영역',
    notAllEdited: '모든 이미지가 편집되지 않음',
    editedXofY: '{total}개 중 {edited}개를 편집했습니다.',
    nextImage: '다음 이미지',
  },

  faqData: {
    imageConverter: [
      { q: '어떤 이미지 형식이 변환에 지원됩니까?', a: 'JPG, PNG, WEBP, SVG, GIF, BMP, ICO, TIFF를 지원합니다. 브라우저에서 즉시 이러한 형식 간에 변환할 수 있습니다.' },
      { q: '변환 중 이미지 품질이 영향을 받나요?', a: 'PNG와 같은 무손실 형식의 경우 품질이 완전히 보존됩니다. JPG, WEBP와 같은 손실 형식의 경우 최상의 시각적 품질을 유지하는 최적화된 인코딩 설정을 사용합니다.' },
      { q: '파일 크기나 수량 제한이 있나요?', a: '엄격한 제한이 없습니다. 여러 이미지를 한 번에 업로드하고 일괄 변환할 수 있습니다.' },
      { q: '내 데이터는 안전한가요? 이미지가 서버에 업로드됩니까?', a: '물론입니다. 모든 처리가 브라우저에서 이루어집니다. 이미지는 기기를 절대 벗어나지 않습니다.' },
      { q: '투명한 PNG 이미지를 JPG로 변환할 수 있나요?', a: '예. JPG는 투명도를 지원하지 않으므로 투명한 영역은 기본적으로 흰색 배경으로 채워집니다.' },
    ],
    imageCompressor: [
      { q: '이미지를 압축하면 품질이 떨어지나요?', a: '아니요. 권장 범위를 넘겨 압축하지 않는 한 이미지 품질은 거의 영향을 받지 않습니다. 품질은 표시 색상으로 안내됩니다. i. 압축 1%~40%: 녹색 표시와 “좋은 품질” 메시지. ii. 압축 41%~60%: 노란색 표시와 “일반 품질” 메시지. 이 구간이 일반적으로 가장 권장됩니다. iii. 압축 61%~100%: 시스템이 “낮은 품질” 빨간 경고를 표시하며, 화질 저하가 눈에 띌 수 있습니다.' },
      { q: '압축에 지원되는 이미지 형식은 무엇인가요?', a: '저희 이미지 압축 도구는 다음 모든 형식을 지원합니다:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: '여러 이미지를 한 번에 압축할 수 있나요?', a: '네, 가능합니다. 기기 성능이 충분하면 여러 이미지(100장 이상도 가능)를 동시에 압축할 수 있습니다. 압축은 기기 자원을 사용하므로 성능이 높은 노트북, PC, 모바일에서 더 빠르게 처리됩니다. 저사양 기기라면 나눠서 배치 처리해도 되고, 여러 번 사용해도 이 도구는 무료입니다.' },
      { q: '이미지를 서버에 업로드하거나 저장하나요?', a: '아니요. 이미지를 서버에 업로드하거나 저장하지 않습니다. 모든 압축은 브라우저에서 로컬로 실행되며, 이미지가 기기를 벗어나지 않습니다. 따라서 개인 이미지나 민감한 이미지도 안심하고 처리할 수 있습니다.' },
      { q: '이 이미지 압축 도구는 무료인가요?', a: '네, 저희 이미지 압축 도구는 영구적으로 완전 무료입니다. 결제를 요청하지 않으며 숨겨진 비용도 없습니다. 다중 이미지 압축을 포함한 모든 기능을 무료로 이용할 수 있습니다.' },
    ],
    cropImage: [
      { q: '이미지를 자르면 품질이 떨어지나요?', a: '아니요, 이미지 자르기는 시각적 품질에 전혀 영향을 주지 않습니다. 자르기는 원하지 않는 부분만 제거합니다. 잘라서 남는 영역의 픽셀은 변경되지 않습니다. 따라서 픽셀 손상 없이 원본 품질 그대로 이미지를 자를 수 있습니다.' },
      { q: '이미지 자르기 도구에서 지원하는 형식은 무엇인가요?', a: '우리 이미지 자르기 도구는 거의 모든 이미지 형식을 지원하므로 어떤 형식의 이미지도 선택할 수 있습니다. 지원 형식은 아래와 같습니다:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: '내 이미지가 서버에 업로드되나요?', a: '아니요, 모든 처리는 로컬 브라우저에서 수행됩니다. 이미지는 기기를 벗어나지 않기 때문에 서버에 업로드되지 않습니다. 따라서 개인 이미지도 위험 없이 우리 이미지 자르기 도구로 처리할 수 있습니다.' },
      { q: '여러 이미지를 동시에 자를 수 있나요?', a: '네, 시스템이 지원하면 여러 이미지(100장 이상도 가능)를 동시에 자를 수 있습니다. 이미지 자르기는 시스템 리소스를 사용하므로 고성능 노트북, PC, 모바일에서는 많은 이미지를 한 번에 처리할 수 있습니다. 저사양 기기라면 배치로 나눠서 자를 수 있으며, 여러 이미지를 처리해도 도구는 무료로 사용할 수 있습니다.' },
      { q: '이 이미지 자르기 도구는 무료인가요?', a: '네, 이 이미지 자르기 도구는 영구적으로 완전 무료입니다. 언제 어디서나 어떤 기기에서든 사용할 수 있습니다. 모든 기기에 맞는 반응형 환경을 제공하며, 프리미엄 기능 결제를 요구하지 않습니다. 모든 기능이 숨겨진 비용 없이 완전 무료입니다.' },
    ],
    resizeImage: [
      { q: '여러 이미지를 한 번에 크기 조정할 수 있나요?', a: '물론입니다. 우리 이미지 리사이즈 도구는 여러 이미지를 한 번에 조정할 수 있습니다. 기기가 지원하는 만큼 이미지를 업로드하면 AI 엔진이 모두 동시에 리사이즈합니다. 다만 저사양 기기라면 지연을 피하기 위해 여러 배치로 나눠 처리하세요. 서버 업로드 없이 기기 리소스로 처리해 이미지 프라이버시를 보호합니다.' },
      { q: '이 이미지 리사이즈 도구는 무료인가요?', a: '네, 이 도구는 영구적으로 무료입니다. 프리미엄 기능을 위해 유료 구독을 요구하지 않습니다. 리사이즈된 이미지를 다운로드할 때 숨겨진 비용도 없습니다.' },
      { q: '이미지를 리사이즈하면 품질이 떨어지나요?', a: '✅Decrease Size (downscale): 이미지 크기를 줄여도 시각적 품질은 떨어지지 않습니다. 오히려 리사이즈된 이미지가 원본보다 더 선명하게 보일 수 있습니다. 따라서 원본보다 작은 크기로 줄이는 것은 품질 저하를 일으키지 않습니다.\n❌Increase Size (upscale): 원본보다 크게 확대하면 시각적 품질에 영향을 줄 수 있습니다. 영향 정도는 확대한 크기에 따라 달라집니다. 크게 확대할수록 품질 저하는 커집니다.' },
      { q: '이 이미지 리사이즈 도구는 안전한가요?', a: '네, 우리 도구는 특히 개인/민감 이미지에 대해 안전합니다. 모든 이미지가 로컬에서 처리되므로 어떤 데이터도 기기를 떠나지 않습니다. 개인 이미지를 위험 없이 리사이즈할 수 있습니다.' },
      { q: '어떤 이미지 형식을 지원하나요?', a: '우리 이미지 리사이저는 모든 이미지 형식을 지원합니다. 다음 형식의 이미지를 선택할 수 있습니다:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: '배경 제거는 어떻게 작동합니까?', a: '브라우저에서 직접 실행되는 고급 AI 모델을 사용하여 피사체를 감지하고 배경과 분리합니다.' },
      { q: '복잡한 배경에서도 작동합니까?', a: '예. AI 모델은 다양한 장면을 처리합니다. 피사체와 배경의 대비가 명확할 때 최상의 결과를 얻습니다.' },
      { q: '여러 이미지에서 동시에 배경을 제거할 수 있나요?', a: '예. 여러 이미지를 업로드하면 도구가 순차적으로 처리합니다.' },
      { q: '출력 형식은 무엇인가요?', a: '출력은 항상 투명 배경이 있는 PNG 파일입니다.' },
      { q: '내 이미지가 서버로 전송됩니까?', a: '아니요. AI 모델이 WebAssembly를 사용하여 브라우저에서 완전히 실행됩니다.' },
    ],
    watermarkImage: [
      { q: '1. Photremium의 워터마크 도구는 무료인가요?', a: '예. photremium.com/watermark-image의 도구는 계정이나 구독 없이 무료로 사용할 수 있습니다. 단일 이미지 또는 배치에 대해 워터마크를 적용할 수 있으며 다운로드 제한이나 강제 등록이 없습니다.' },
      { q: '2. 한번에 몇 개의 이미지를 처리할 수 있나요?', a: '배치 처리를 지원합니다. 전체 폴더를 드래그 앤 드롭하거나 파일 선택기로 여러 파일을 한 번에 선택할 수 있습니다. 실제 제한은 기기 메모리에 따라 달라집니다.' },
      { q: '3. 입력 및 출력에서 어떤 이미지 형식을 지원하나요?', a: '브라우저 File API로 처리 가능한 형식을 지원합니다: JPEG, JPG, PNG, WEBP, GIF(정적), BMP, SVG입니다. 출력은 원본 형식을 유지합니다.' },
      { q: '4. 해상도가 다른 이미지에서도 워터마크가 동일하게 보이나요?', a: '예. 비례 재배치 엔진이 기준 이미지의 중심과 상대적 위치를 계산하여 각 대상 이미지에 동일한 비율로 적용합니다.' },
      { q: '5. 텍스트 대신 자체 로고를 워터마크로 사용할 수 있나요?', a: '예. "Add Image" 버튼으로 투명 배경 PNG를 업로드하면 투명도가 유지되며 워터마크 레이어로 사용할 수 있습니다.' },
      { q: '6. 워터마크를 반투명으로 만드는 방법은?', a: '캔버스에서 워터마크 레이어를 선택한 후 불투명도 슬라이더를 조정하세요. 30~50%가 일반적으로 적당합니다.' },
      { q: '7. 한 이미지에 여러 워터마크 레이어를 추가할 수 있나요?', a: '예. 레이어 시스템은 무제한 레이어를 지원하며 각 레이어는 개별 설정이 가능합니다.' },
      { q: '8. 타일링 기능은 무엇이고 언제 사용하나요?', a: '타일링은 워터마크를 그리드로 반복하여 이미지 전체를 덮습니다. 무단 사용을 방지하려는 경우에 유용합니다.' },
      { q: '9. 모바일에서도 작동하나요?', a: '예. 반응형 인터페이스로 작은 화면에서는 레이아웃이 스택으로 바뀌며 모든 제어가 터치에 최적화됩니다.' },
      { q: '10. 내 이미지가 개인 정보로 보호되나요? 서버로 전송되나요?', a: '이미지는 기기를 벗어나지 않습니다. 모든 처리는 브라우저 내에서 Canvas API로 로컬 실행되며 이미지 데이터 업로드는 없습니다.' },
    ],
    qrCodeGenerator: [
      { q: '이 QR 코드는 만료되나요?', a: '아니요, 이 QR 코드는 만료되지 않으며 평생 사용할 수 있습니다. QR 코드는 정사각형 셀 안에 비트 형태로 하드코딩된 정보를 저장하므로, 저장된 정보는 변경하거나 삭제할 수 없습니다. 수년이 지나도 어떤 카메라로든 스캔만 하면 코드에 담긴 정보를 확인할 수 있습니다.' },
      { q: '왜 제 QR 코드가 스캔되지 않나요?', a: '다음과 같은 이유로 QR 코드 스캔이 실패할 수 있습니다: i. 낮은 대비: 배경색과 전경색이 너무 비슷하면 QR 코드 가시성이 떨어져 스캔이 실패할 수 있습니다. 하지만 저희 도구는 커스터마이징 중 낮은 대비나 기타 스캔 문제를 안내해 줍니다. ii. 데이터 과다: 너무 긴 텍스트를 넣어 QR 코드를 만들면 코드가 매우 복잡해져 스캔이 어려워집니다. 텍스트 길이 검증기가 생성 중 최적 길이를 안내해 줍니다. iii. 흐린 인쇄: PNG 또는 SVG처럼 고해상도 형식으로 QR 코드를 다운로드하세요. 두 형식 모두 저희 도구에서 지원됩니다.' },
      { q: 'QR 코드에 로고를 추가할 수 있나요?', a: '물론입니다. 사용자 지정 로고를 추가하거나 내장 로고 라이브러리에서 로고를 선택할 수 있습니다. 선택한 로고는 QR 코드 중앙에 자동으로 맞춰 적용됩니다.' },
      { q: 'QR 코드는 어떻게 스캔하나요?', a: '휴대폰 카메라로 QR 코드를 스캔할 수 있습니다. 자동 링크 이동과 더 많은 고급 기능이 필요하다면 https://photremium.com/qr-code-scanner 에서 무료 QR 코드 스캐너를 이용할 수 있습니다.' },
      { q: '무료로 몇 개의 QR 코드를 만들 수 있나요?', a: '무제한입니다! 무료로 여러 개의 QR 코드를 생성할 수 있습니다. 모든 기능, 커스터마이징, 템플릿은 모두에게 영구적으로 무료입니다. 프리미엄 기능을 쓰기 위해 구독할 필요가 없습니다.' },
      { q: 'QR 코드를 만들려면 로그인/회원가입이 필요한가요?', a: '아니요. 텍스트를 입력하고 QR 코드를 생성한 뒤 커스터마이징 후 다운로드하면 됩니다. 로그인이나 회원가입 없이 모든 기능을 완전히 무료로 사용할 수 있습니다.' },
    ],
    qrCodeScanner: [
      { q: '저장된 이미지나 스크린샷에서 QR 코드를 스캔할 수 있나요?', a: '**예**, 저장된 이미지 또는 스크린샷에서 QR 코드를 스캔할 수 있습니다. 우리 QR 코드 스캐너 https://photremium.com/qr-code-scanner 에서 갤러리 스캔을 지원합니다. 이미지를 선택하면 해당 QR 코드에서 복원된 정보를 모두 확인할 수 있습니다.' },
      { q: 'QR 코드 스캐너를 위해 앱을 설치해야 하나요?', a: '**아니요**, 웹 기반 QR 코드 스캐너라서 별도 앱 설치가 필요 없습니다. 어떤 기기에서든 무료로 고급 QR 스캔 기능을 사용할 수 있습니다.' },
      { q: '왜 스캐너가 QR 코드를 인식하지 못하나요?', a: '다음과 같은 이유일 수 있습니다: i. 조명이 부족함: 어두운 환경에서는 스캔이 어렵습니다. 화면에서 스캔하는 경우 플래시를 켜고 밝기를 높이세요. ii. 거리 문제: 너무 가깝거나 멀면 인식이 어렵습니다. 권장 거리는 약 10인치(25cm)입니다. iii. 렌즈 오염: 카메라 렌즈가 더러우면 스캔 실패가 발생할 수 있습니다. 스캔 전에 렌즈를 닦아주세요. “스캐너에 박스 격자가 보이나요? QR 코드를 그 안에 맞추면 성공적으로 스캔됩니다.”' },
      { q: '이 도구는 반전되거나 컬러인 QR 코드도 스캔할 수 있나요?', a: '**예**, 색상이나 방향에 관계없이 스캔할 수 있습니다. 다만 배경색과 전경색의 대비가 낮으면 스캔이 어려울 수 있습니다.' },
      { q: '이 도구는 무료인가요?', a: '**예**, 이 도구는 완전히 무료입니다. QR 코드를 무제한으로 계속 무료 스캔할 수 있습니다.' },
    ],
    faceBlur: [
      { q: '얼굴 감지는 어떻게 작동합니까?', a: 'AI 기반 얼굴 감지 모델이 브라우저에서 직접 실행됩니다. 이미지의 얼굴을 식별합니다.' },
      { q: '블러 처리할 얼굴을 선택할 수 있나요?', a: '예. 감지 후 각 얼굴 영역이 강조 표시되며 블러 처리할 얼굴을 선택할 수 있습니다.' },
      { q: '어떤 블러 스타일을 사용할 수 있나요?', a: '가우시안 블러, 픽셀화, 단색 오버레이 중에서 선택할 수 있으며 강도를 조절할 수 있습니다.' },
      { q: '여러 이미지에서 동시에 얼굴을 블러 처리할 수 있나요?', a: '예. 여러 이미지를 업로드하고 블러 영역을 구성한 후 모든 처리된 이미지를 다운로드하세요.' },
      { q: '내 사진이 원격 서버로 전송됩니까?', a: '아니요. AI 모델이 WebAssembly를 사용하여 브라우저에서 실행됩니다.' },
    ],
    photoEditor: [
      { q: '어떤 편집 기능을 사용할 수 있나요?', a: '밝기, 대비, 채도 조정, 필터 적용, 텍스트, 오버레이, 프레임, 스티커 추가 등 — 모두 브라우저 내에서.' },
      { q: '변경 사항을 취소하고 다시 실행할 수 있나요?', a: '예. 편집기는 완전한 실행 취소/다시 실행 기록을 지원합니다.' },
      { q: '어떤 파일 형식을 편집하고 내보낼 수 있나요?', a: 'JPG, PNG, WEBP 및 기타 일반 형식을 편집할 수 있습니다.' },
      { q: '편집기가 모바일에서 작동합니까?', a: '예. 편집기는 완전히 반응형이며 터치 친화적입니다.' },
      { q: '내 이미지가 서버에 저장됩니까?', a: '아니요. 모든 편집이 로컬에서 이루어집니다.' },
    ],
  },
};

export default ko;
